/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Javascript Date object */
  DateTime: { input: string; output: string };
  /** Scalar representing email. */
  Email: { input: any; output: any };
  /** Scalar representing an error code in mutation response payload. */
  ErrorCode: { input: any; output: any };
  /** Scalar representing an field in mutation response payload. */
  Field: { input: any; output: any };
  JSONObject: { input: unknown; output: unknown };
  /** Scalar representing phone number. */
  PhoneNumber: { input: any; output: any };
};

export type Account = INode & {
  __typename?: 'Account';
  autoResetInvoiceNo: Scalars['Boolean']['output'];
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankAccountNo?: Maybe<Scalars['String']['output']>;
  canManage: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  creditNotification: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitations: Array<AccountInvitation>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  members: Array<AccountMember>;
  name: Scalars['String']['output'];
  nextInvoiceNo: Scalars['Int']['output'];
  plan: AccountPlan;
  statusUpdateFrequency: StatusUpdateFrequency;
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<TagDefinition>;
};

export type AccountInvitation = INode & {
  __typename?: 'AccountInvitation';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['Email']['output'];
  expiresAfter: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy: Scalars['ID']['output'];
  inviter: User;
  roles: Array<AccountMemberRole>;
};

export type AccountInvitationPayload = IMutationPayload & {
  __typename?: 'AccountInvitationPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<RequestError>>;
  invitationEmail?: Maybe<Scalars['String']['output']>;
  invitationLink?: Maybe<Scalars['String']['output']>;
};

export type AccountLogoUploadPayload = {
  __typename?: 'AccountLogoUploadPayload';
  logoId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type AccountMember = INode & {
  __typename?: 'AccountMember';
  accountId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  member: User;
  roles: Array<AccountMemberRole>;
  userId: Scalars['ID']['output'];
};

export type AccountMemberRole = 'manager' | 'owner' | 'tenant';

export type AccountPayload = IMutationPayload & {
  __typename?: 'AccountPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<RequestError>>;
};

export type AccountPlan = 'free' | 'standard' | 'unlimited';

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  creator?: Maybe<User>;
  id: Scalars['ID']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Address>;
  company?: Maybe<Scalars['String']['output']>;
  companyNo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role: ContactRole;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type ContactCreateInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  companyNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: ContactRole;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactRole = 'AGENT' | 'ALLOWED' | 'OTHER' | 'TENANT';

export type ContactUpdateInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  companyNo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: ContactRole;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type Contract = INode & {
  __typename?: 'Contract';
  accountId: Scalars['ID']['output'];
  /** Whether the user can manage this contract */
  canManage: Scalars['Boolean']['output'];
  comments: Array<Comment>;
  contacts: Array<Contact>;
  contractHid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  /** Tenancy end date */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<FileRef>;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  mainUnit?: Maybe<Unit>;
  note: Scalars['String']['output'];
  /** Contract signing date */
  signingDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tenancy start date */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  tasks: Array<Task>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  terminationReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** List of units that are part of this contract */
  unitIds: Array<Scalars['ID']['output']>;
  units: Array<Unit>;
};

export type ContractPayload = IMutationPayload & {
  __typename?: 'ContractPayload';
  contract?: Maybe<Contract>;
  errors?: Maybe<Array<RequestError>>;
};

export type CreateAccountInvitationInput = {
  email: Scalars['Email']['input'];
  roles: Array<AccountMemberRole>;
};

export type CreateCommentInput = {
  comment: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  content?: InputMaybe<Scalars['JSONObject']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateExpenseInput = {
  amount: Scalars['Float']['input'];
  date: Scalars['DateTime']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  isCost?: InputMaybe<Scalars['Boolean']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  taxDeductible?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateExpensePaymentInput = {
  amount: Scalars['Float']['input'];
  expenseId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type CreateInvoiceInput = {
  contractId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['Float']['input'];
};

export type CreateInvoicePaymentInput = {
  amount: Scalars['Float']['input'];
  invoiceId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type CreateMoneyTransactionInput = {
  bankAccountNo: Scalars['String']['input'];
  cash: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  otherAccountNo?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['DateTime']['input'];
  type: TransactionType;
  value: Scalars['Float']['input'];
};

export type CreateRecurringExpenseInput = {
  amount: Scalars['Float']['input'];
  dueDays: Scalars['Int']['input'];
  frequency: RecurringExpenseFrequency;
  nextDate: Scalars['DateTime']['input'];
  refNo?: InputMaybe<Scalars['String']['input']>;
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxDeductible?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateRecurringInvoiceInput = {
  contractId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  dueDays: Scalars['Int']['input'];
  frequency: RecurringInvoiceFrequency;
  nextDate: Scalars['DateTime']['input'];
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: Scalars['Float']['input'];
};

export type CreateRecurringTaskInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDays: Scalars['Int']['input'];
  frequency: RecurringTaskFrequency;
  nextDate: Scalars['DateTime']['input'];
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTaskInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: TaskStatus;
  title: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUnitInput = {
  name: Scalars['String']['input'];
};

export type DateFormatType = 'DMY' | 'MDY' | 'YMD';

export type Document = INode & {
  __typename?: 'Document';
  accountId: Scalars['ID']['output'];
  /** stringified json */
  content: Scalars['JSONObject']['output'];
  contract?: Maybe<Contract>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manager?: Maybe<User>;
  managerUserId?: Maybe<Scalars['ID']['output']>;
  signedOffByManagerAt?: Maybe<Scalars['DateTime']['output']>;
  signedOffByTenantAt?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<Scalars['String']['output']>;
  tenant?: Maybe<User>;
  tenantUserId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: DocumentType;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentType =
  /** inspection story */
  'inspection';

export type Expense = INode & {
  __typename?: 'Expense';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCost?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy: Scalars['ID']['output'];
  paidAmount: Scalars['Float']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payments: Array<ExpensePayment>;
  refNo?: Maybe<Scalars['String']['output']>;
  taxDeductible: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unitAssignments: Array<ExpenseUnitAssignment>;
};

export type ExpensePayload = IMutationPayload & {
  __typename?: 'ExpensePayload';
  errors?: Maybe<Array<RequestError>>;
  expense?: Maybe<Expense>;
};

export type ExpensePayment = INode & {
  __typename?: 'ExpensePayment';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expense?: Maybe<Expense>;
  expenseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  transaction?: Maybe<MoneyTransaction>;
  transactionId: Scalars['ID']['output'];
};

export type ExpensePaymentPayload = IMutationPayload & {
  __typename?: 'ExpensePaymentPayload';
  errors?: Maybe<Array<RequestError>>;
  expensePayment?: Maybe<ExpensePayment>;
};

export type ExpenseUnitAssignment = {
  __typename?: 'ExpenseUnitAssignment';
  amount: Scalars['Float']['output'];
  expenseId: Scalars['ID']['output'];
  unit?: Maybe<Unit>;
  unitId: Scalars['ID']['output'];
};

export type ExpenseUnitAssignmentInput = {
  amount: Scalars['Float']['input'];
  unitId: Scalars['ID']['input'];
};

export type FileRef = {
  __typename?: 'FileRef';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  urlMd?: Maybe<Scalars['String']['output']>;
  urlXs?: Maybe<Scalars['String']['output']>;
};

export type FileRefDocType =
  /** account logo */
  | 'al'
  /** contract doc */
  | 'cd'
  /** document attachment */
  | 'da'
  /** unit doc private */
  | 'pdp'
  /** unit doc tenant */
  | 'pdt'
  /** unit photo */
  | 'pp';

export type FileRefUploadInput = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type FileRefUploadPayload = {
  __typename?: 'FileRefUploadPayload';
  fileId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** Represents a payload of data that can return validation errors */
export type IMutationPayload = {
  errors?: Maybe<Array<RequestError>>;
};

/** Represents objects with globally unique id */
export type INode = {
  id: Scalars['ID']['output'];
};

export type InvitationPayload = IMutationPayload & {
  __typename?: 'InvitationPayload';
  account?: Maybe<Account>;
  errors?: Maybe<Array<RequestError>>;
  user?: Maybe<User>;
};

export type Invoice = INode & {
  __typename?: 'Invoice';
  accountId: Scalars['ID']['output'];
  comments: Array<Comment>;
  contract?: Maybe<Contract>;
  contractId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceNo?: Maybe<Scalars['String']['output']>;
  isDraft: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  paidAmount: Scalars['Float']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payments: Array<InvoicePayment>;
  recInvoiceId?: Maybe<Scalars['ID']['output']>;
  refNo?: Maybe<Scalars['String']['output']>;
  rows: Array<InvoiceRow>;
  totalAmount: Scalars['Float']['output'];
  unitAssignments: Array<InvoiceUnitAssignment>;
};

export type InvoicePayload = IMutationPayload & {
  __typename?: 'InvoicePayload';
  errors?: Maybe<Array<RequestError>>;
  invoice?: Maybe<Invoice>;
};

export type InvoicePayment = INode & {
  __typename?: 'InvoicePayment';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['ID']['output'];
  transaction?: Maybe<MoneyTransaction>;
  transactionId: Scalars['ID']['output'];
};

export type InvoicePaymentPayload = IMutationPayload & {
  __typename?: 'InvoicePaymentPayload';
  errors?: Maybe<Array<RequestError>>;
  invoicePayment?: Maybe<InvoicePayment>;
};

export type InvoiceRow = {
  __typename?: 'InvoiceRow';
  discount: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  rowNumber: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type InvoiceRowInput = {
  discount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  rowNumber: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type InvoiceUnitAssignment = {
  __typename?: 'InvoiceUnitAssignment';
  amount: Scalars['Float']['output'];
  invoiceId: Scalars['ID']['output'];
  unit?: Maybe<Unit>;
  unitId: Scalars['ID']['output'];
};

export type InvoiceUnitAssignmentInput = {
  amount: Scalars['Float']['input'];
  unitId: Scalars['ID']['input'];
};

export type LanguageType = 'sk';

export type MoneyTransaction = INode & {
  __typename?: 'MoneyTransaction';
  accountId: Scalars['ID']['output'];
  bankAccountNo: Scalars['String']['output'];
  cash: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  doNotReconcile?: Maybe<Scalars['Boolean']['output']>;
  expensePayments: Array<ExpensePayment>;
  id: Scalars['ID']['output'];
  invoicePayments: Array<InvoicePayment>;
  note?: Maybe<Scalars['String']['output']>;
  otherAccountNo?: Maybe<Scalars['String']['output']>;
  reconciledValue: Scalars['Float']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  transactionDate: Scalars['DateTime']['output'];
  type: TransactionType;
  value: Scalars['Float']['output'];
};

export type MoneyTransactionFilterInput = {
  showUnreconciledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MoneyTransactionPayload = IMutationPayload & {
  __typename?: 'MoneyTransactionPayload';
  errors?: Maybe<Array<RequestError>>;
  moneyTransaction?: Maybe<MoneyTransaction>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Placeholder type as graphQL does not allow to define empty types */
  _?: Maybe<Scalars['Boolean']['output']>;
  acceptInvitation: InvitationPayload;
  addContactToContract: ContractPayload;
  addContractComment?: Maybe<ContractPayload>;
  addDocumentToContract: ContractPayload;
  addDocumentToUnit: UnitPayload;
  addExpenseComment?: Maybe<ExpensePayload>;
  addFileAttachmentToDocument: FileRefUploadPayload;
  addFileToContract: FileRefUploadPayload;
  addFileToUnit: FileRefUploadPayload;
  addInvoiceComment?: Maybe<InvoicePayload>;
  addInvoiceRow: InvoicePayload;
  addRecurringInvoiceRow: RecurringInvoicePayload;
  addTaskComment: TaskPayload;
  addTenantToContract: ContractPayload;
  addUnitComment?: Maybe<UnitPayload>;
  addUnitPhoto: FileRefUploadPayload;
  addUnitTask?: Maybe<UnitPayload>;
  addUnitToContract: ContractPayload;
  addUrlAttachmentToDocument: FileRef;
  archiveUnit: UnitPayload;
  confirmAccountLogoUpload: AccountPayload;
  confirmFileAttachmentUploadedToDocument: FileRef;
  confirmFileUploadedToContract: ContractPayload;
  confirmFileUploadedToUnit: UnitPayload;
  confirmUnitPhotoUpload: UnitPayload;
  copyInvoice: InvoicePayload;
  copyRecurringInvoice: RecurringInvoicePayload;
  createContract: ContractPayload;
  createExpense: ExpensePayload;
  createExpensePayment: ExpensePaymentPayload;
  createInvoice: InvoicePayload;
  createInvoicePayment: InvoicePaymentPayload;
  createMoneyTransaction: MoneyTransactionPayload;
  createRecurringExpense: RecurringExpensePayload;
  createRecurringInvoice: RecurringInvoicePayload;
  createRecurringTask: RecurringTaskPayload;
  createTask: TaskPayload;
  createUnit: UnitPayload;
  deleteAccountInvitation: AccountPayload;
  deleteAttachmentFromDocument: FileRef;
  deleteContract: ContractPayload;
  deleteDocumentFromContract: ContractPayload;
  deleteDocumentFromUnit: UnitPayload;
  deleteExpense: ExpensePayload;
  deleteExpensePayment: ExpensePaymentPayload;
  deleteFileFromContract: FileRef;
  deleteFileFromUnit: FileRef;
  deleteInvoice: InvoicePayload;
  deleteInvoicePayment: InvoicePaymentPayload;
  deleteMoneyTransaction: MoneyTransactionPayload;
  deleteRecurringExpense: RecurringExpensePayload;
  deleteRecurringInvoice: RecurringInvoicePayload;
  deleteRecurringTask: RecurringTaskPayload;
  deleteTask: TaskPayload;
  deleteTaskComment: TaskPayload;
  deleteUnit: UnitPayload;
  deleteUnitPhoto: FileRef;
  inviteUserToAccount: AccountInvitationPayload;
  issueInvoice: InvoicePayload;
  markExpensePaid: ExpensePayload;
  markExpenseUnpaid: ExpensePayload;
  markInvoicePaid: InvoicePayload;
  markInvoiceUnpaid: InvoicePayload;
  moveInvoiceRowDown: InvoicePayload;
  moveInvoiceRowUp: InvoicePayload;
  moveRecurringInvoiceRowDown: RecurringInvoicePayload;
  moveRecurringInvoiceRowUp: RecurringInvoicePayload;
  removeContactFromContract: ContractPayload;
  removeContractComment?: Maybe<ContractPayload>;
  removeExpenseComment?: Maybe<ExpensePayload>;
  removeInvoiceComment?: Maybe<InvoicePayload>;
  removeInvoiceRow: InvoicePayload;
  removeMemberFromAccount: AccountPayload;
  removeRecurringInvoiceRow: RecurringInvoicePayload;
  removeTenantFromContract: ContractPayload;
  removeUnitComment?: Maybe<UnitPayload>;
  removeUnitFromContract: ContractPayload;
  removeUnitTask?: Maybe<UnitPayload>;
  sendInvoiceInformationEmail: InvoicePayload;
  sendPaymentConfirmation: InvoicePayload;
  sendStatusUpdate: AccountPayload;
  setExpenseUnitAssignments: ExpensePayload;
  setInvoiceUnitAssignments: InvoicePayload;
  setPlan: AccountPayload;
  setRecurringExpenseUnitAssignments: RecurringExpensePayload;
  setRecurringInvoiceUnitAssignments: RecurringInvoicePayload;
  setUnitCoverPhoto: UnitPayload;
  signContract: ContractPayload;
  startRentingUnit: UnitPayload;
  stopRentingUnit: UnitPayload;
  suspendRecurringExpense: RecurringExpensePayload;
  suspendRecurringInvoice: RecurringInvoicePayload;
  suspendRecurringTask: RecurringTaskPayload;
  terminateContract: ContractPayload;
  unarchiveUnit: UnitPayload;
  undeleteContract: ContractPayload;
  undeleteExpense: ExpensePayload;
  undeleteInvoice: InvoicePayload;
  undeleteRecurringExpense: RecurringExpensePayload;
  undeleteRecurringInvoice: RecurringInvoicePayload;
  undeleteRecurringTask: RecurringTaskPayload;
  undeleteTask: TaskPayload;
  undeleteUnit: UnitPayload;
  unsignContract: ContractPayload;
  unsuspendRecurringExpense: RecurringExpensePayload;
  unsuspendRecurringInvoice: RecurringInvoicePayload;
  unsuspendRecurringTask: RecurringTaskPayload;
  unterminateContract: ContractPayload;
  updateAccount: AccountPayload;
  updateContactInContract: ContractPayload;
  updateContract: ContractPayload;
  updateContractComment?: Maybe<ContractPayload>;
  updateDocumentInContract: ContractPayload;
  updateDocumentInUnit: UnitPayload;
  updateExpense: ExpensePayload;
  updateExpenseComment?: Maybe<ExpensePayload>;
  updateFileInContract: FileRef;
  updateFileInUnit: FileRef;
  updateInvoice: InvoicePayload;
  updateInvoiceComment?: Maybe<InvoicePayload>;
  updateInvoiceRow: InvoicePayload;
  updateMoneyTransaction: MoneyTransactionPayload;
  updateNotificationSettings: NotificationSettingsPayload;
  updateRecurringExpense: RecurringExpensePayload;
  updateRecurringInvoice: RecurringInvoicePayload;
  updateRecurringInvoiceRow: RecurringInvoicePayload;
  updateRecurringTask: RecurringTaskPayload;
  updateTask: TaskPayload;
  updateTaskComment: TaskPayload;
  updateTenantInContract: ContractPayload;
  updateUnit: UnitPayload;
  updateUnitComment?: Maybe<UnitPayload>;
  updateUnitPhotoCaption: FileRef;
  updateUnitTask?: Maybe<UnitPayload>;
  updateUser: UserPayload;
  uploadAccountLogo: AccountLogoUploadPayload;
};

export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};

export type MutationAddContactToContractArgs = {
  contractId: Scalars['ID']['input'];
  input: ContactCreateInput;
};

export type MutationAddContractCommentArgs = {
  contractId: Scalars['ID']['input'];
  input: CreateCommentInput;
};

export type MutationAddDocumentToContractArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<CreateDocumentInput>;
};

export type MutationAddDocumentToUnitArgs = {
  input?: InputMaybe<CreateDocumentInput>;
  unitId: Scalars['ID']['input'];
};

export type MutationAddExpenseCommentArgs = {
  expenseId: Scalars['ID']['input'];
  input: CreateCommentInput;
};

export type MutationAddFileAttachmentToDocumentArgs = {
  documentId: Scalars['ID']['input'];
  input?: InputMaybe<FileRefUploadInput>;
  type: FileRefDocType;
};

export type MutationAddFileToContractArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<FileRefUploadInput>;
  type: FileRefDocType;
};

export type MutationAddFileToUnitArgs = {
  input?: InputMaybe<FileRefUploadInput>;
  type: FileRefDocType;
  unitId: Scalars['ID']['input'];
};

export type MutationAddInvoiceCommentArgs = {
  input: CreateCommentInput;
  invoiceId: Scalars['ID']['input'];
};

export type MutationAddInvoiceRowArgs = {
  input: InvoiceRowInput;
  invoiceId: Scalars['ID']['input'];
};

export type MutationAddRecurringInvoiceRowArgs = {
  input: RecurringInvoiceRowInput;
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationAddTaskCommentArgs = {
  input: CreateCommentInput;
  taskId: Scalars['ID']['input'];
};

export type MutationAddTenantToContractArgs = {
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<ContactCreateInput>;
};

export type MutationAddUnitCommentArgs = {
  input: CreateCommentInput;
  unitId: Scalars['ID']['input'];
};

export type MutationAddUnitPhotoArgs = {
  input?: InputMaybe<FileRefUploadInput>;
  unitId: Scalars['ID']['input'];
};

export type MutationAddUnitTaskArgs = {
  input: CreateTaskInput;
  unitId: Scalars['ID']['input'];
};

export type MutationAddUnitToContractArgs = {
  contractId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationAddUrlAttachmentToDocumentArgs = {
  documentId: Scalars['ID']['input'];
  type: FileRefDocType;
  url: Scalars['String']['input'];
};

export type MutationArchiveUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationConfirmAccountLogoUploadArgs = {
  logoId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
};

export type MutationConfirmFileAttachmentUploadedToDocumentArgs = {
  documentId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
};

export type MutationConfirmFileUploadedToContractArgs = {
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
};

export type MutationConfirmFileUploadedToUnitArgs = {
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationConfirmUnitPhotoUploadArgs = {
  photoId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationCopyInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationCopyRecurringInvoiceArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};

export type MutationCreateExpensePaymentArgs = {
  input: CreateExpensePaymentInput;
};

export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};

export type MutationCreateInvoicePaymentArgs = {
  input: CreateInvoicePaymentInput;
};

export type MutationCreateMoneyTransactionArgs = {
  input: CreateMoneyTransactionInput;
};

export type MutationCreateRecurringExpenseArgs = {
  input: CreateRecurringExpenseInput;
};

export type MutationCreateRecurringInvoiceArgs = {
  input: CreateRecurringInvoiceInput;
};

export type MutationCreateRecurringTaskArgs = {
  input: CreateRecurringTaskInput;
};

export type MutationCreateTaskArgs = {
  input?: InputMaybe<CreateTaskInput>;
};

export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};

export type MutationDeleteAccountInvitationArgs = {
  accountId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
};

export type MutationDeleteAttachmentFromDocumentArgs = {
  documentId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};

export type MutationDeleteContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type MutationDeleteDocumentFromContractArgs = {
  contractId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteDocumentFromUnitArgs = {
  documentId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationDeleteExpenseArgs = {
  expenseId: Scalars['ID']['input'];
};

export type MutationDeleteExpensePaymentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFileFromContractArgs = {
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};

export type MutationDeleteFileFromUnitArgs = {
  fileId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationDeleteInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationDeleteInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMoneyTransactionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRecurringExpenseArgs = {
  recurringExpenseId: Scalars['ID']['input'];
};

export type MutationDeleteRecurringInvoiceArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationDeleteRecurringTaskArgs = {
  recurringTaskId: Scalars['ID']['input'];
};

export type MutationDeleteTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationDeleteTaskCommentArgs = {
  commentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export type MutationDeleteUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationDeleteUnitPhotoArgs = {
  photoId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationInviteUserToAccountArgs = {
  accountId: Scalars['ID']['input'];
  input: CreateAccountInvitationInput;
};

export type MutationIssueInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationMarkExpensePaidArgs = {
  expenseId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
};

export type MutationMarkExpenseUnpaidArgs = {
  expenseId: Scalars['ID']['input'];
};

export type MutationMarkInvoicePaidArgs = {
  invoiceId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
};

export type MutationMarkInvoiceUnpaidArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationMoveInvoiceRowDownArgs = {
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationMoveInvoiceRowUpArgs = {
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationMoveRecurringInvoiceRowDownArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationMoveRecurringInvoiceRowUpArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationRemoveContactFromContractArgs = {
  contactId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
};

export type MutationRemoveContractCommentArgs = {
  commentId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
};

export type MutationRemoveExpenseCommentArgs = {
  commentId: Scalars['ID']['input'];
  expenseId: Scalars['ID']['input'];
};

export type MutationRemoveInvoiceCommentArgs = {
  commentId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type MutationRemoveInvoiceRowArgs = {
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationRemoveMemberFromAccountArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveRecurringInvoiceRowArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationRemoveTenantFromContractArgs = {
  contractId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

export type MutationRemoveUnitCommentArgs = {
  commentId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationRemoveUnitFromContractArgs = {
  contractId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationRemoveUnitTaskArgs = {
  taskId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationSendInvoiceInformationEmailArgs = {
  emails?: InputMaybe<Scalars['String']['input']>;
  includeDefaultRecipients: Scalars['Boolean']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type MutationSendPaymentConfirmationArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationSetExpenseUnitAssignmentsArgs = {
  assignments: Array<ExpenseUnitAssignmentInput>;
  expenseId: Scalars['ID']['input'];
};

export type MutationSetInvoiceUnitAssignmentsArgs = {
  assignments: Array<InvoiceUnitAssignmentInput>;
  invoiceId: Scalars['ID']['input'];
};

export type MutationSetPlanArgs = {
  accountId: Scalars['ID']['input'];
  plan: AccountPlan;
};

export type MutationSetRecurringExpenseUnitAssignmentsArgs = {
  assignments: Array<RecurringExpenseUnitAssignmentInput>;
  recurringExpenseId: Scalars['ID']['input'];
};

export type MutationSetRecurringInvoiceUnitAssignmentsArgs = {
  assignments: Array<RecurringInvoiceUnitAssignmentInput>;
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationSetUnitCoverPhotoArgs = {
  photoId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationSignContractArgs = {
  contractId: Scalars['ID']['input'];
  signingDate: Scalars['DateTime']['input'];
};

export type MutationStartRentingUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationStopRentingUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationSuspendRecurringExpenseArgs = {
  recurringExpenseId: Scalars['ID']['input'];
};

export type MutationSuspendRecurringInvoiceArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationSuspendRecurringTaskArgs = {
  recurringTaskId: Scalars['ID']['input'];
};

export type MutationTerminateContractArgs = {
  contractId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  terminationDate: Scalars['DateTime']['input'];
};

export type MutationUnarchiveUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationUndeleteContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type MutationUndeleteExpenseArgs = {
  expenseId: Scalars['ID']['input'];
};

export type MutationUndeleteInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationUndeleteRecurringExpenseArgs = {
  recurringExpenseId: Scalars['ID']['input'];
};

export type MutationUndeleteRecurringInvoiceArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationUndeleteRecurringTaskArgs = {
  recurringTaskId: Scalars['ID']['input'];
};

export type MutationUndeleteTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationUndeleteUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type MutationUnsignContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type MutationUnsuspendRecurringExpenseArgs = {
  recurringExpenseId: Scalars['ID']['input'];
};

export type MutationUnsuspendRecurringInvoiceArgs = {
  recurringInvoiceId: Scalars['ID']['input'];
};

export type MutationUnsuspendRecurringTaskArgs = {
  recurringTaskId: Scalars['ID']['input'];
};

export type MutationUnterminateContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

export type MutationUpdateContactInContractArgs = {
  contractId: Scalars['ID']['input'];
  input: ContactUpdateInput;
};

export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};

export type MutationUpdateContractCommentArgs = {
  contractId: Scalars['ID']['input'];
  input: UpdateCommentInput;
};

export type MutationUpdateDocumentInContractArgs = {
  contractId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};

export type MutationUpdateDocumentInUnitArgs = {
  documentId: Scalars['ID']['input'];
  input: UpdateDocumentInput;
  unitId: Scalars['ID']['input'];
};

export type MutationUpdateExpenseArgs = {
  expenseId: Scalars['ID']['input'];
  input: UpdateExpenseInput;
};

export type MutationUpdateExpenseCommentArgs = {
  expenseId: Scalars['ID']['input'];
  input: UpdateCommentInput;
};

export type MutationUpdateFileInContractArgs = {
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  input: UpdateFileInput;
};

export type MutationUpdateFileInUnitArgs = {
  fileId: Scalars['ID']['input'];
  input: UpdateFileInput;
  unitId: Scalars['ID']['input'];
};

export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
  invoiceId: Scalars['ID']['input'];
};

export type MutationUpdateInvoiceCommentArgs = {
  input: UpdateCommentInput;
  invoiceId: Scalars['ID']['input'];
};

export type MutationUpdateInvoiceRowArgs = {
  input: InvoiceRowInput;
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationUpdateMoneyTransactionArgs = {
  input: UpdateMoneyTransactionInput;
};

export type MutationUpdateNotificationSettingsArgs = {
  accountId: Scalars['ID']['input'];
  input: UpdateNotificationSettingsInput;
};

export type MutationUpdateRecurringExpenseArgs = {
  input: UpdateRecurringExpenseInput;
};

export type MutationUpdateRecurringInvoiceArgs = {
  input: UpdateRecurringInvoiceInput;
};

export type MutationUpdateRecurringInvoiceRowArgs = {
  input: RecurringInvoiceRowInput;
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type MutationUpdateRecurringTaskArgs = {
  input: UpdateRecurringTaskInput;
  recurringTaskId: Scalars['ID']['input'];
};

export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};

export type MutationUpdateTaskCommentArgs = {
  input: UpdateCommentInput;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTenantInContractArgs = {
  contractId: Scalars['ID']['input'];
  input: ContactUpdateInput;
};

export type MutationUpdateUnitArgs = {
  input: UpdateUnitInput;
};

export type MutationUpdateUnitCommentArgs = {
  input: UpdateCommentInput;
  unitId: Scalars['ID']['input'];
};

export type MutationUpdateUnitPhotoCaptionArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  photoId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
};

export type MutationUpdateUnitTaskArgs = {
  input: UpdateTaskInput;
  unitId: Scalars['ID']['input'];
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  userId: Scalars['ID']['input'];
};

export type MutationUploadAccountLogoArgs = {
  input: FileRefUploadInput;
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  daysBefore: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NotificationInput = {
  active: Scalars['Boolean']['input'];
  daysBefore: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type NotificationSettings = INode & {
  __typename?: 'NotificationSettings';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceInformationSubject?: Maybe<Scalars['String']['output']>;
  invoiceInformationText?: Maybe<Scalars['String']['output']>;
  notificationBccEmails?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  paymentConfirmationEnabled: Scalars['Boolean']['output'];
  paymentConfirmationSubject?: Maybe<Scalars['String']['output']>;
  paymentConfirmationText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationSettingsPayload = IMutationPayload & {
  __typename?: 'NotificationSettingsPayload';
  errors?: Maybe<Array<RequestError>>;
  notificationSettings?: Maybe<NotificationSettings>;
};

export type NumberFormatType = 'DE' | 'UK' | 'US';

export type PlanUsage = {
  __typename?: 'PlanUsage';
  current: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  limit: Scalars['Float']['output'];
  limitName: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Placeholder type as graphQL does not allow to define empty types */
  _?: Maybe<Scalars['Boolean']['output']>;
  getAccountById?: Maybe<Account>;
  getAccountPlanUsage: Array<PlanUsage>;
  getAccounts: Array<Account>;
  getAccountsInvitingUser: Array<Account>;
  getContract?: Maybe<Contract>;
  getContracts: Array<Contract>;
  getDocument?: Maybe<Document>;
  getDocumentsForContract: Array<Document>;
  getDocumentsForUnit: Array<Document>;
  getExpense?: Maybe<Expense>;
  getExpensePayment?: Maybe<ExpensePayment>;
  getExpensePaymentsForExpense: Array<ExpensePayment>;
  getExpensesForAccount: Array<Expense>;
  getExpensesForUnit: Array<Expense>;
  getInvoice?: Maybe<Invoice>;
  getInvoicePayment?: Maybe<InvoicePayment>;
  getInvoicePaymentsForInvoice: Array<InvoicePayment>;
  getInvoicePaymentsForTransaction: Array<InvoicePayment>;
  getInvoicesForAccount: Array<Invoice>;
  getInvoicesForContract: Array<Invoice>;
  getMoneyTransaction?: Maybe<MoneyTransaction>;
  getMoneyTransactionsForAccount: Array<MoneyTransaction>;
  getNotificationSettings?: Maybe<NotificationSettings>;
  getRecurringExpense?: Maybe<RecurringExpense>;
  getRecurringExpensesForAccount: Array<RecurringExpense>;
  getRecurringExpensesForUnit: Array<RecurringExpense>;
  getRecurringInvoice?: Maybe<RecurringInvoice>;
  getRecurringInvoicesForAccount: Array<RecurringInvoice>;
  getRecurringInvoicesForContract: Array<RecurringInvoice>;
  getRecurringTask?: Maybe<RecurringTask>;
  getRecurringTasksForAccount: Array<RecurringTask>;
  getRecurringTasksForContract: Array<RecurringTask>;
  getRecurringTasksForUnit: Array<RecurringTask>;
  getTask?: Maybe<Task>;
  getTasks: Array<Task>;
  getTasksForContract: Array<Task>;
  getTasksForUnit: Array<Task>;
  /** Get a unit by id. If unit is not found, or is not accessible by the current account, an error is thrown. */
  getUnit?: Maybe<Unit>;
  /** Get all units for the current account. By default returns new and active units. Set includeArchived to true to get only archived units. */
  getUnits: Array<Unit>;
  getUnpaidExpenses: Array<Expense>;
  getUnpaidInvoices: Array<Invoice>;
  getUserById?: Maybe<User>;
  getUsers: Array<User>;
  verifyAccountInvitation?: Maybe<AccountInvitation>;
};

export type QueryGetAccountByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAccountsInvitingUserArgs = {
  email: Scalars['Email']['input'];
};

export type QueryGetContractArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetDocumentArgs = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetDocumentsForContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryGetDocumentsForUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type QueryGetExpenseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetExpensePaymentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetExpensePaymentsForExpenseArgs = {
  expenseId: Scalars['ID']['input'];
};

export type QueryGetExpensesForUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type QueryGetInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetInvoicePaymentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetInvoicePaymentsForInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryGetInvoicePaymentsForTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};

export type QueryGetInvoicesForContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryGetMoneyTransactionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetMoneyTransactionsForAccountArgs = {
  filter?: InputMaybe<MoneyTransactionFilterInput>;
};

export type QueryGetNotificationSettingsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryGetRecurringExpenseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetRecurringExpensesForUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type QueryGetRecurringInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetRecurringInvoicesForContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryGetRecurringTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetRecurringTasksForContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryGetRecurringTasksForUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type QueryGetTaskArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetTasksForContractArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryGetTasksForUnitArgs = {
  unitId: Scalars['ID']['input'];
};

export type QueryGetUnitArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetUnitsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetUserByIdArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryVerifyAccountInvitationArgs = {
  accountId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type RecurringExpense = INode & {
  __typename?: 'RecurringExpense';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDays: Scalars['Int']['output'];
  frequency: RecurringExpenseFrequency;
  id: Scalars['ID']['output'];
  nextDate: Scalars['DateTime']['output'];
  refNo?: Maybe<Scalars['String']['output']>;
  stopAfterDate?: Maybe<Scalars['DateTime']['output']>;
  suspended: Scalars['Boolean']['output'];
  taxDeductible: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unitAssignments: Array<RecurringExpenseUnitAssignment>;
};

export type RecurringExpenseFrequency = 'M' | 'M2' | 'M3' | 'M6' | 'W' | 'W2' | 'Y';

export type RecurringExpensePayload = IMutationPayload & {
  __typename?: 'RecurringExpensePayload';
  errors?: Maybe<Array<RequestError>>;
  recurringExpense?: Maybe<RecurringExpense>;
};

export type RecurringExpenseUnitAssignment = {
  __typename?: 'RecurringExpenseUnitAssignment';
  amount: Scalars['Float']['output'];
  recExpenseId: Scalars['ID']['output'];
  unit?: Maybe<Unit>;
  unitId: Scalars['ID']['output'];
};

export type RecurringExpenseUnitAssignmentInput = {
  amount: Scalars['Float']['input'];
  unitId: Scalars['ID']['input'];
};

export type RecurringInvoice = INode & {
  __typename?: 'RecurringInvoice';
  accountId: Scalars['ID']['output'];
  contract?: Maybe<Contract>;
  contractId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dueDays: Scalars['Int']['output'];
  frequency: RecurringInvoiceFrequency;
  id: Scalars['ID']['output'];
  nextDate: Scalars['DateTime']['output'];
  rows: Array<RecurringInvoiceRow>;
  stopAfterDate?: Maybe<Scalars['DateTime']['output']>;
  suspended: Scalars['Boolean']['output'];
  totalAmount: Scalars['Float']['output'];
  unitAssignments: Array<RecurringInvoiceUnitAssignment>;
};

export type RecurringInvoiceFrequency = 'M' | 'M2' | 'M3' | 'M6' | 'W' | 'W2' | 'Y';

export type RecurringInvoicePayload = IMutationPayload & {
  __typename?: 'RecurringInvoicePayload';
  errors?: Maybe<Array<RequestError>>;
  recurringInvoice?: Maybe<RecurringInvoice>;
};

export type RecurringInvoiceRow = {
  __typename?: 'RecurringInvoiceRow';
  discount: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  rowNumber: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type RecurringInvoiceRowInput = {
  discount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  rowNumber: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type RecurringInvoiceUnitAssignment = {
  __typename?: 'RecurringInvoiceUnitAssignment';
  amount: Scalars['Float']['output'];
  recInvoiceId: Scalars['ID']['output'];
  unit?: Maybe<Unit>;
  unitId: Scalars['ID']['output'];
};

export type RecurringInvoiceUnitAssignmentInput = {
  amount: Scalars['Float']['input'];
  unitId: Scalars['ID']['input'];
};

export type RecurringTask = INode & {
  __typename?: 'RecurringTask';
  accountId: Scalars['ID']['output'];
  contract?: Maybe<Contract>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDays: Scalars['Int']['output'];
  frequency: RecurringTaskFrequency;
  id: Scalars['ID']['output'];
  nextDate: Scalars['DateTime']['output'];
  stopAfterDate?: Maybe<Scalars['DateTime']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['ID']['output']>;
};

export type RecurringTaskFrequency =
  | 'M'
  | 'M2'
  | 'M3'
  | 'M4'
  | 'M6'
  | 'W'
  | 'W2'
  | 'W4'
  | 'Y'
  | 'Y2'
  | 'Y3'
  | 'Y4'
  | 'Y5';

export type RecurringTaskPayload = IMutationPayload & {
  __typename?: 'RecurringTaskPayload';
  errors?: Maybe<Array<RequestError>>;
  recurringTask?: Maybe<RecurringTask>;
};

/** Represents request error */
export type RequestError = {
  __typename?: 'RequestError';
  /** An error code for clients to match on. */
  code: Scalars['ErrorCode']['output'];
  /** Indicates which field caused the error */
  field?: Maybe<Scalars['Field']['output']>;
};

export type StatusUpdateFrequency = 'daily' | 'none' | 'weekly';

export type TagDefinition = {
  __typename?: 'TagDefinition';
  color?: Maybe<Scalars['String']['output']>;
  entityType: TagEntityType;
  name: Scalars['String']['output'];
};

export type TagDefinitionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  entityType: TagEntityType;
  name: Scalars['String']['input'];
};

export type TagEntityType = 'document';

export type Task = INode & {
  __typename?: 'Task';
  accountId: Scalars['ID']['output'];
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignee?: Maybe<User>;
  comments: Array<Comment>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contract?: Maybe<Contract>;
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastComment?: Maybe<Comment>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  title: Scalars['String']['output'];
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskPayload = IMutationPayload & {
  __typename?: 'TaskPayload';
  errors?: Maybe<Array<RequestError>>;
  task?: Maybe<Task>;
};

export type TaskStatus = 'completed' | 'in_progress' | 'todo';

export type TimeFormatType = 'H12' | 'H24';

export type TransactionType = 'CREDIT' | 'DEBIT';

export type Unit = INode & {
  __typename?: 'Unit';
  accountId: Scalars['ID']['output'];
  address: Scalars['String']['output'];
  /** Whether the current account can manage this unit. */
  canManage: Scalars['Boolean']['output'];
  comments: Array<Comment>;
  coverPhoto?: Maybe<FileRef>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documents: Array<Document>;
  expenses: Array<Expense>;
  /** The files that are shared with tenants. e.g. inventory, equipment manuals, floorplan etc. */
  filesForTenant: Array<FileRef>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  photos: Array<FileRef>;
  status: UnitStatus;
  tasks: Array<Task>;
  /** The documents/files associated with this unit, but not shared with tenants. e.g. insurance contract, s contracts etc. */
  unitFiles: Array<FileRef>;
};

export type UnitPayload = IMutationPayload & {
  __typename?: 'UnitPayload';
  errors?: Maybe<Array<RequestError>>;
  unit?: Maybe<Unit>;
};

export type UnitStatus = 'archived' | 'not_renting' | 'renting';

export type UpdateAccountInput = {
  autoResetInvoiceNo?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  creditNotification?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextInvoiceNo?: InputMaybe<Scalars['Int']['input']>;
  statusUpdateFrequency?: InputMaybe<StatusUpdateFrequency>;
  tags?: InputMaybe<Array<TagDefinitionInput>>;
};

export type UpdateCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateContractInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentInput = {
  content?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  taxDeductible?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFileInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMoneyTransactionInput = {
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReconcile?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  otherAccountNo?: InputMaybe<Scalars['String']['input']>;
  reconciledValue?: InputMaybe<Scalars['Float']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<TransactionType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateNotificationSettingsInput = {
  invoiceInformationSubject?: InputMaybe<Scalars['String']['input']>;
  invoiceInformationText?: InputMaybe<Scalars['String']['input']>;
  notificationBccEmails?: InputMaybe<Scalars['String']['input']>;
  notifications: Array<NotificationInput>;
  paymentConfirmationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentConfirmationSubject?: InputMaybe<Scalars['String']['input']>;
  paymentConfirmationText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecurringExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  dueDays?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<RecurringExpenseFrequency>;
  id: Scalars['ID']['input'];
  nextDate?: InputMaybe<Scalars['DateTime']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxDeductible?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecurringInvoiceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDays?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<RecurringInvoiceFrequency>;
  id: Scalars['ID']['input'];
  nextDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRecurringTaskInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDays?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<RecurringTaskFrequency>;
  nextDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTaskInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TaskStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUnitInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fmtDate?: InputMaybe<DateFormatType>;
  /** Formatting */
  fmtNum?: InputMaybe<NumberFormatType>;
  fmtTime?: InputMaybe<TimeFormatType>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  lang?: InputMaybe<LanguageType>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Time Zone */
  tz?: InputMaybe<Scalars['String']['input']>;
};

export type User = INode & {
  __typename?: 'User';
  account: Account;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  fmtDate: DateFormatType;
  /** Formatting */
  fmtNum: NumberFormatType;
  fmtTime: TimeFormatType;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Language */
  lang: LanguageType;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Time Zone */
  tz: Scalars['String']['output'];
};

export type UserPayload = IMutationPayload & {
  __typename?: 'UserPayload';
  errors?: Maybe<Array<RequestError>>;
  user?: Maybe<User>;
};

export type AccountPayloadFragment = {
  __typename?: 'AccountPayload';
  account?: {
    __typename?: 'Account';
    id: string;
    name: string;
    creatorId: string;
    nextInvoiceNo: number;
    autoResetInvoiceNo: boolean;
    bankAccountNo?: string | null;
    bankAccountName?: string | null;
    logoUrl?: string | null;
    statusUpdateFrequency: StatusUpdateFrequency;
    creditNotification: boolean;
    suspendedAt?: string | null;
    deletedAt?: string | null;
    canManage: boolean;
    tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
    members: Array<{
      __typename?: 'AccountMember';
      id: string;
      accountId: string;
      userId: string;
      roles: Array<AccountMemberRole>;
      deletedAt?: string | null;
      member: {
        __typename?: 'User';
        tz: string;
        lang: LanguageType;
        fmtNum: NumberFormatType;
        fmtDate: DateFormatType;
        fmtTime: TimeFormatType;
        isAdmin?: boolean | null;
        isSuperAdmin?: boolean | null;
        createdAt: string;
        disabledAt?: string | null;
        deletedAt?: string | null;
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      };
    }>;
    invitations: Array<{
      __typename?: 'AccountInvitation';
      id: string;
      email: any;
      roles: Array<AccountMemberRole>;
      expiresAfter: string;
      invitedBy: string;
      deletedAt?: string | null;
      inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
    }>;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type AccountInvitationPayloadFragment = {
  __typename?: 'AccountInvitationPayload';
  invitationLink?: string | null;
  invitationEmail?: string | null;
  account?: {
    __typename?: 'Account';
    id: string;
    name: string;
    creatorId: string;
    nextInvoiceNo: number;
    autoResetInvoiceNo: boolean;
    bankAccountNo?: string | null;
    bankAccountName?: string | null;
    logoUrl?: string | null;
    statusUpdateFrequency: StatusUpdateFrequency;
    creditNotification: boolean;
    suspendedAt?: string | null;
    deletedAt?: string | null;
    canManage: boolean;
    tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
    members: Array<{
      __typename?: 'AccountMember';
      id: string;
      accountId: string;
      userId: string;
      roles: Array<AccountMemberRole>;
      deletedAt?: string | null;
      member: {
        __typename?: 'User';
        tz: string;
        lang: LanguageType;
        fmtNum: NumberFormatType;
        fmtDate: DateFormatType;
        fmtTime: TimeFormatType;
        isAdmin?: boolean | null;
        isSuperAdmin?: boolean | null;
        createdAt: string;
        disabledAt?: string | null;
        deletedAt?: string | null;
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      };
    }>;
    invitations: Array<{
      __typename?: 'AccountInvitation';
      id: string;
      email: any;
      roles: Array<AccountMemberRole>;
      expiresAfter: string;
      invitedBy: string;
      deletedAt?: string | null;
      inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
    }>;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateAccount: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UploadAccountLogoMutationVariables = Exact<{
  input: FileRefUploadInput;
}>;

export type UploadAccountLogoMutation = {
  __typename?: 'Mutation';
  uploadAccountLogo: { __typename?: 'AccountLogoUploadPayload'; uploadUrl: string; logoId: string };
};

export type ConfirmAccountLogoUploadMutationVariables = Exact<{
  logoId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
}>;

export type ConfirmAccountLogoUploadMutation = {
  __typename?: 'Mutation';
  confirmAccountLogoUpload: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveMemberFromAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveMemberFromAccountMutation = {
  __typename?: 'Mutation';
  removeMemberFromAccount: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type InviteUserToAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: CreateAccountInvitationInput;
}>;

export type InviteUserToAccountMutation = {
  __typename?: 'Mutation';
  inviteUserToAccount: {
    __typename?: 'AccountInvitationPayload';
    invitationLink?: string | null;
    invitationEmail?: string | null;
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteAccountInvitationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
}>;

export type DeleteAccountInvitationMutation = {
  __typename?: 'Mutation';
  deleteAccountInvitation: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SendStatusUpdateMutationVariables = Exact<{ [key: string]: never }>;

export type SendStatusUpdateMutation = {
  __typename?: 'Mutation';
  sendStatusUpdate: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SetPlanMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  plan: AccountPlan;
}>;

export type SetPlanMutation = {
  __typename?: 'Mutation';
  setPlan: {
    __typename?: 'AccountPayload';
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetAccountByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAccountByIdQuery = {
  __typename?: 'Query';
  getAccountById?: {
    __typename?: 'Account';
    id: string;
    name: string;
    creatorId: string;
    nextInvoiceNo: number;
    autoResetInvoiceNo: boolean;
    bankAccountNo?: string | null;
    bankAccountName?: string | null;
    logoUrl?: string | null;
    statusUpdateFrequency: StatusUpdateFrequency;
    creditNotification: boolean;
    suspendedAt?: string | null;
    deletedAt?: string | null;
    canManage: boolean;
    tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
    members: Array<{
      __typename?: 'AccountMember';
      id: string;
      accountId: string;
      userId: string;
      roles: Array<AccountMemberRole>;
      deletedAt?: string | null;
      member: {
        __typename?: 'User';
        tz: string;
        lang: LanguageType;
        fmtNum: NumberFormatType;
        fmtDate: DateFormatType;
        fmtTime: TimeFormatType;
        isAdmin?: boolean | null;
        isSuperAdmin?: boolean | null;
        createdAt: string;
        disabledAt?: string | null;
        deletedAt?: string | null;
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      };
    }>;
    invitations: Array<{
      __typename?: 'AccountInvitation';
      id: string;
      email: any;
      roles: Array<AccountMemberRole>;
      expiresAfter: string;
      invitedBy: string;
      deletedAt?: string | null;
      inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
    }>;
  } | null;
};

export type GetAccountsInvitingUserQueryVariables = Exact<{
  email: Scalars['Email']['input'];
}>;

export type GetAccountsInvitingUserQuery = {
  __typename?: 'Query';
  getAccountsInvitingUser: Array<{
    __typename?: 'Account';
    id: string;
    name: string;
    plan: AccountPlan;
    creatorId: string;
    nextInvoiceNo: number;
    autoResetInvoiceNo: boolean;
    bankAccountNo?: string | null;
    bankAccountName?: string | null;
    logoUrl?: string | null;
    statusUpdateFrequency: StatusUpdateFrequency;
    creditNotification: boolean;
    suspendedAt?: string | null;
    deletedAt?: string | null;
    canManage: boolean;
    tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
  }>;
};

export type GetAccountPlanUsageQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountPlanUsageQuery = {
  __typename?: 'Query';
  getAccountPlanUsage: Array<{
    __typename?: 'PlanUsage';
    id: string;
    limitName: string;
    limit: number;
    current: number;
  }>;
};

export type ContractPayloadFragment = {
  __typename?: 'ContractPayload';
  contract?: {
    __typename?: 'Contract';
    id: string;
    contractHid?: string | null;
    title: string;
    note: string;
    signingDate?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    terminationDate?: string | null;
    terminationReason?: string | null;
    deletedAt?: string | null;
    createdAt: string;
    canManage: boolean;
    mainUnit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    units: Array<{
      __typename?: 'Unit';
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }>;
    files: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contacts: Array<{
      __typename?: 'Contact';
      id: string;
      role: ContactRole;
      name: string;
      email?: string | null;
      phone?: string | null;
      company?: string | null;
      companyNo?: string | null;
      taxId?: string | null;
      note?: string | null;
      address?: {
        __typename?: 'Address';
        id?: string | null;
        street1?: string | null;
        street2?: string | null;
        city: string;
        state?: string | null;
        zip?: string | null;
        country?: string | null;
      } | null;
    }>;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type CreateContractMutationVariables = Exact<{ [key: string]: never }>;

export type CreateContractMutation = {
  __typename?: 'Mutation';
  createContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;

export type UpdateContractMutation = {
  __typename?: 'Mutation';
  updateContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type UndeleteContractMutation = {
  __typename?: 'Mutation';
  undeleteContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type DeleteContractMutation = {
  __typename?: 'Mutation';
  deleteContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SignContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  signingDate: Scalars['DateTime']['input'];
}>;

export type SignContractMutation = {
  __typename?: 'Mutation';
  signContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnsignContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type UnsignContractMutation = {
  __typename?: 'Mutation';
  unsignContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type TerminateContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  terminationDate: Scalars['DateTime']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type TerminateContractMutation = {
  __typename?: 'Mutation';
  terminateContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnterminateContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type UnterminateContractMutation = {
  __typename?: 'Mutation';
  unterminateContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddUnitToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
}>;

export type AddUnitToContractMutation = {
  __typename?: 'Mutation';
  addUnitToContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveUnitFromContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  unitId: Scalars['ID']['input'];
}>;

export type RemoveUnitFromContractMutation = {
  __typename?: 'Mutation';
  removeUnitFromContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddFileToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  type: FileRefDocType;
  input: FileRefUploadInput;
}>;

export type AddFileToContractMutation = {
  __typename?: 'Mutation';
  addFileToContract: { __typename?: 'FileRefUploadPayload'; uploadUrl: string; fileId: string };
};

export type ConfirmFileUploadedToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
}>;

export type ConfirmFileUploadedToContractMutation = {
  __typename?: 'Mutation';
  confirmFileUploadedToContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateFileInContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  input: UpdateFileInput;
}>;

export type UpdateFileInContractMutation = {
  __typename?: 'Mutation';
  updateFileInContract: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type DeleteFileFromContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;

export type DeleteFileFromContractMutation = {
  __typename?: 'Mutation';
  deleteFileFromContract: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type AddContactToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: ContactCreateInput;
}>;

export type AddContactToContractMutation = {
  __typename?: 'Mutation';
  addContactToContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveContactFromContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;

export type RemoveContactFromContractMutation = {
  __typename?: 'Mutation';
  removeContactFromContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateContactInContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: ContactUpdateInput;
}>;

export type UpdateContactInContractMutation = {
  __typename?: 'Mutation';
  updateContactInContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddTenantToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input?: InputMaybe<ContactCreateInput>;
}>;

export type AddTenantToContractMutation = {
  __typename?: 'Mutation';
  addTenantToContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveTenantFromContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;

export type RemoveTenantFromContractMutation = {
  __typename?: 'Mutation';
  removeTenantFromContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateTenantInContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: ContactUpdateInput;
}>;

export type UpdateTenantInContractMutation = {
  __typename?: 'Mutation';
  updateTenantInContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddContractCommentMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: CreateCommentInput;
}>;

export type AddContractCommentMutation = {
  __typename?: 'Mutation';
  addContractComment?: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type UpdateContractCommentMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;

export type UpdateContractCommentMutation = {
  __typename?: 'Mutation';
  updateContractComment?: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type RemoveContractCommentMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;

export type RemoveContractCommentMutation = {
  __typename?: 'Mutation';
  removeContractComment?: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type AddDocumentToContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  input: CreateDocumentInput;
}>;

export type AddDocumentToContractMutation = {
  __typename?: 'Mutation';
  addDocumentToContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteDocumentFromContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;

export type DeleteDocumentFromContractMutation = {
  __typename?: 'Mutation';
  deleteDocumentFromContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateDocumentInContractMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  input: UpdateDocumentInput;
}>;

export type UpdateDocumentInContractMutation = {
  __typename?: 'Mutation';
  updateDocumentInContract: {
    __typename?: 'ContractPayload';
    contract?: {
      __typename?: 'Contract';
      id: string;
      contractHid?: string | null;
      title: string;
      note: string;
      signingDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      terminationDate?: string | null;
      terminationReason?: string | null;
      deletedAt?: string | null;
      createdAt: string;
      canManage: boolean;
      mainUnit?: {
        __typename?: 'Unit';
        description: string;
        note: string;
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        photos: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        unitFiles: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        filesForTenant: Array<{
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        }>;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        tasks: Array<{
          __typename?: 'Task';
          id: string;
          title: string;
          description?: string | null;
          status: TaskStatus;
          startDate?: string | null;
          dueDate?: string | null;
          completedAt?: string | null;
          assignedTo?: string | null;
          unitId?: string | null;
          contractId?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          assignee?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          lastComment?: {
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          } | null;
        }>;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          type: DocumentType;
          title: string;
          description?: string | null;
          content: unknown;
          tags: Array<string>;
          unitId?: string | null;
          contractId?: string | null;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          signedOffByTenantAt?: string | null;
          signedOffByManagerAt?: string | null;
          tenantUserId?: string | null;
          managerUserId?: string | null;
          unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
          contract?: { __typename?: 'Contract'; id: string; title: string } | null;
          tenant?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
          manager?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        expenses: Array<{
          __typename?: 'Expense';
          id: string;
          accountId: string;
          title: string;
          amount: number;
          taxDeductible: number;
          date: string;
          dueDate: string;
          refNo?: string | null;
          paidAt?: string | null;
          paidAmount: number;
          isCost?: boolean | null;
          createdAt: string;
          modifiedAt: string;
          modifiedBy: string;
          deletedAt?: string | null;
          deletedBy?: string | null;
          comments: Array<{
            __typename?: 'Comment';
            id: string;
            comment: string;
            createdAt: string;
            createdBy?: string | null;
            creator?: {
              __typename?: 'User';
              id: string;
              fullName?: string | null;
              email: string;
              phone?: any | null;
            } | null;
          }>;
          payments: Array<{
            __typename?: 'ExpensePayment';
            id: string;
            accountId: string;
            transactionId: string;
            expenseId: string;
            amount: number;
            createdAt: string;
            createdBy?: string | null;
            deletedAt?: string | null;
            expense?: { __typename?: 'Expense'; id: string; title: string } | null;
          }>;
          unitAssignments: Array<{
            __typename?: 'ExpenseUnitAssignment';
            unitId: string;
            expenseId: string;
            amount: number;
            unit?: { __typename?: 'Unit'; id: string; name: string } | null;
          }>;
        }>;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      } | null;
      units: Array<{
        __typename?: 'Unit';
        address: string;
        id: string;
        accountId: string;
        name: string;
        status: UnitStatus;
        deletedAt?: string | null;
        canManage: boolean;
        coverPhoto?: {
          __typename?: 'FileRef';
          id: string;
          name?: string | null;
          desc?: string | null;
          tags: Array<string>;
          url: string;
          urlXs?: string | null;
          urlMd?: string | null;
          mimeType: string;
          size: number;
          uploadedAt?: string | null;
          deletedAt?: string | null;
        } | null;
      }>;
      files: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contacts: Array<{
        __typename?: 'Contact';
        id: string;
        role: ContactRole;
        name: string;
        email?: string | null;
        phone?: string | null;
        company?: string | null;
        companyNo?: string | null;
        taxId?: string | null;
        note?: string | null;
        address?: {
          __typename?: 'Address';
          id?: string | null;
          street1?: string | null;
          street2?: string | null;
          city: string;
          state?: string | null;
          zip?: string | null;
          country?: string | null;
        } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetContractsQueryVariables = Exact<{ [key: string]: never }>;

export type GetContractsQuery = {
  __typename?: 'Query';
  getContracts: Array<{
    __typename?: 'Contract';
    id: string;
    contractHid?: string | null;
    title: string;
    note: string;
    signingDate?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    terminationDate?: string | null;
    terminationReason?: string | null;
    deletedAt?: string | null;
    createdAt: string;
    canManage: boolean;
    mainUnit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    units: Array<{
      __typename?: 'Unit';
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }>;
    files: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contacts: Array<{
      __typename?: 'Contact';
      id: string;
      role: ContactRole;
      name: string;
      email?: string | null;
      phone?: string | null;
      company?: string | null;
      companyNo?: string | null;
      taxId?: string | null;
      note?: string | null;
      address?: {
        __typename?: 'Address';
        id?: string | null;
        street1?: string | null;
        street2?: string | null;
        city: string;
        state?: string | null;
        zip?: string | null;
        country?: string | null;
      } | null;
    }>;
  }>;
};

export type GetContractQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetContractQuery = {
  __typename?: 'Query';
  getContract?: {
    __typename?: 'Contract';
    id: string;
    contractHid?: string | null;
    title: string;
    note: string;
    signingDate?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    terminationDate?: string | null;
    terminationReason?: string | null;
    deletedAt?: string | null;
    createdAt: string;
    canManage: boolean;
    mainUnit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    units: Array<{
      __typename?: 'Unit';
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    }>;
    files: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contacts: Array<{
      __typename?: 'Contact';
      id: string;
      role: ContactRole;
      name: string;
      email?: string | null;
      phone?: string | null;
      company?: string | null;
      companyNo?: string | null;
      taxId?: string | null;
      note?: string | null;
      address?: {
        __typename?: 'Address';
        id?: string | null;
        street1?: string | null;
        street2?: string | null;
        city: string;
        state?: string | null;
        zip?: string | null;
        country?: string | null;
      } | null;
    }>;
  } | null;
};

export type AddFileAttachmentToDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  type: FileRefDocType;
  input?: InputMaybe<FileRefUploadInput>;
}>;

export type AddFileAttachmentToDocumentMutation = {
  __typename?: 'Mutation';
  addFileAttachmentToDocument: { __typename?: 'FileRefUploadPayload'; uploadUrl: string; fileId: string };
};

export type ConfirmFileAttachmentUploadedToDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
}>;

export type ConfirmFileAttachmentUploadedToDocumentMutation = {
  __typename?: 'Mutation';
  confirmFileAttachmentUploadedToDocument: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type AddUrlAttachmentToDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  type: FileRefDocType;
  url: Scalars['String']['input'];
}>;

export type AddUrlAttachmentToDocumentMutation = {
  __typename?: 'Mutation';
  addUrlAttachmentToDocument: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type DeleteAttachmentFromDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;

export type DeleteAttachmentFromDocumentMutation = {
  __typename?: 'Mutation';
  deleteAttachmentFromDocument: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type GetDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type GetDocumentQuery = {
  __typename?: 'Query';
  getDocument?: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    title: string;
    description?: string | null;
    content: unknown;
    tags: Array<string>;
    unitId?: string | null;
    contractId?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    signedOffByTenantAt?: string | null;
    signedOffByManagerAt?: string | null;
    tenantUserId?: string | null;
    managerUserId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  } | null;
};

export type GetDocumentsForContractQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type GetDocumentsForContractQuery = {
  __typename?: 'Query';
  getDocumentsForContract: Array<{
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    title: string;
    description?: string | null;
    content: unknown;
    tags: Array<string>;
    unitId?: string | null;
    contractId?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    signedOffByTenantAt?: string | null;
    signedOffByManagerAt?: string | null;
    tenantUserId?: string | null;
    managerUserId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
};

export type GetDocumentsForUnitQueryVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type GetDocumentsForUnitQuery = {
  __typename?: 'Query';
  getDocumentsForUnit: Array<{
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    title: string;
    description?: string | null;
    content: unknown;
    tags: Array<string>;
    unitId?: string | null;
    contractId?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    signedOffByTenantAt?: string | null;
    signedOffByManagerAt?: string | null;
    tenantUserId?: string | null;
    managerUserId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
};

export type CreateExpensePaymentMutationVariables = Exact<{
  input: CreateExpensePaymentInput;
}>;

export type CreateExpensePaymentMutation = {
  __typename?: 'Mutation';
  createExpensePayment: {
    __typename?: 'ExpensePaymentPayload';
    expensePayment?: {
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteExpensePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteExpensePaymentMutation = {
  __typename?: 'Mutation';
  deleteExpensePayment: {
    __typename?: 'ExpensePaymentPayload';
    expensePayment?: {
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetExpensePaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetExpensePaymentQuery = {
  __typename?: 'Query';
  getExpensePayment?: {
    __typename?: 'ExpensePayment';
    id: string;
    accountId: string;
    transactionId: string;
    expenseId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    expense?: { __typename?: 'Expense'; id: string; title: string } | null;
  } | null;
};

export type GetExpensePaymentsForExpenseQueryVariables = Exact<{
  expenseId: Scalars['ID']['input'];
}>;

export type GetExpensePaymentsForExpenseQuery = {
  __typename?: 'Query';
  getExpensePaymentsForExpense: Array<{
    __typename?: 'ExpensePayment';
    id: string;
    accountId: string;
    transactionId: string;
    expenseId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    expense?: { __typename?: 'Expense'; id: string; title: string } | null;
  }>;
};

export type GetUnpaidExpensesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnpaidExpensesQuery = {
  __typename?: 'Query';
  getUnpaidExpenses: Array<{
    __typename?: 'Expense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    date: string;
    dueDate: string;
    refNo?: string | null;
    paidAt?: string | null;
    paidAmount: number;
    isCost?: boolean | null;
    createdAt: string;
    modifiedAt: string;
    modifiedBy: string;
    deletedAt?: string | null;
    deletedBy?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    payments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'ExpenseUnitAssignment';
      unitId: string;
      expenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type CreateExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;

export type CreateExpenseMutation = {
  __typename?: 'Mutation';
  createExpense: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateExpenseMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  input: UpdateExpenseInput;
}>;

export type UpdateExpenseMutation = {
  __typename?: 'Mutation';
  updateExpense: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteExpenseMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
}>;

export type DeleteExpenseMutation = {
  __typename?: 'Mutation';
  deleteExpense: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteExpenseMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
}>;

export type UndeleteExpenseMutation = {
  __typename?: 'Mutation';
  undeleteExpense: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MarkExpensePaidMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
}>;

export type MarkExpensePaidMutation = {
  __typename?: 'Mutation';
  markExpensePaid: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MarkExpenseUnpaidMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
}>;

export type MarkExpenseUnpaidMutation = {
  __typename?: 'Mutation';
  markExpenseUnpaid: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddExpenseCommentMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  input: CreateCommentInput;
}>;

export type AddExpenseCommentMutation = {
  __typename?: 'Mutation';
  addExpenseComment?: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type UpdateExpenseCommentMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;

export type UpdateExpenseCommentMutation = {
  __typename?: 'Mutation';
  updateExpenseComment?: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type RemoveExpenseCommentMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;

export type RemoveExpenseCommentMutation = {
  __typename?: 'Mutation';
  removeExpenseComment?: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type SetExpenseUnitAssignmentsMutationVariables = Exact<{
  expenseId: Scalars['ID']['input'];
  assignments: Array<ExpenseUnitAssignmentInput> | ExpenseUnitAssignmentInput;
}>;

export type SetExpenseUnitAssignmentsMutation = {
  __typename?: 'Mutation';
  setExpenseUnitAssignments: {
    __typename?: 'ExpensePayload';
    expense?: {
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetExpenseQuery = {
  __typename?: 'Query';
  getExpense?: {
    __typename?: 'Expense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    date: string;
    dueDate: string;
    refNo?: string | null;
    paidAt?: string | null;
    paidAmount: number;
    isCost?: boolean | null;
    createdAt: string;
    modifiedAt: string;
    modifiedBy: string;
    deletedAt?: string | null;
    deletedBy?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    payments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'ExpenseUnitAssignment';
      unitId: string;
      expenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  } | null;
};

export type GetExpensesForAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetExpensesForAccountQuery = {
  __typename?: 'Query';
  getExpensesForAccount: Array<{
    __typename?: 'Expense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    date: string;
    dueDate: string;
    refNo?: string | null;
    paidAt?: string | null;
    paidAmount: number;
    isCost?: boolean | null;
    createdAt: string;
    modifiedAt: string;
    modifiedBy: string;
    deletedAt?: string | null;
    deletedBy?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    payments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'ExpenseUnitAssignment';
      unitId: string;
      expenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type GetExpensesForUnitQueryVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type GetExpensesForUnitQuery = {
  __typename?: 'Query';
  getExpensesForUnit: Array<{
    __typename?: 'Expense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    date: string;
    dueDate: string;
    refNo?: string | null;
    paidAt?: string | null;
    paidAmount: number;
    isCost?: boolean | null;
    createdAt: string;
    modifiedAt: string;
    modifiedBy: string;
    deletedAt?: string | null;
    deletedBy?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    payments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'ExpenseUnitAssignment';
      unitId: string;
      expenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type AccountMemberFragment = {
  __typename?: 'AccountMember';
  id: string;
  accountId: string;
  userId: string;
  roles: Array<AccountMemberRole>;
  deletedAt?: string | null;
  member: {
    __typename?: 'User';
    tz: string;
    lang: LanguageType;
    fmtNum: NumberFormatType;
    fmtDate: DateFormatType;
    fmtTime: TimeFormatType;
    isAdmin?: boolean | null;
    isSuperAdmin?: boolean | null;
    createdAt: string;
    disabledAt?: string | null;
    deletedAt?: string | null;
    id: string;
    fullName?: string | null;
    email: string;
    phone?: any | null;
  };
};

export type AccountBaseFragment = {
  __typename?: 'Account';
  id: string;
  name: string;
  plan: AccountPlan;
  creatorId: string;
  nextInvoiceNo: number;
  autoResetInvoiceNo: boolean;
  bankAccountNo?: string | null;
  bankAccountName?: string | null;
  logoUrl?: string | null;
  statusUpdateFrequency: StatusUpdateFrequency;
  creditNotification: boolean;
  suspendedAt?: string | null;
  deletedAt?: string | null;
  canManage: boolean;
  tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
};

export type AccountFragment = {
  __typename?: 'Account';
  id: string;
  name: string;
  creatorId: string;
  nextInvoiceNo: number;
  autoResetInvoiceNo: boolean;
  bankAccountNo?: string | null;
  bankAccountName?: string | null;
  logoUrl?: string | null;
  statusUpdateFrequency: StatusUpdateFrequency;
  creditNotification: boolean;
  suspendedAt?: string | null;
  deletedAt?: string | null;
  canManage: boolean;
  tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
  members: Array<{
    __typename?: 'AccountMember';
    id: string;
    accountId: string;
    userId: string;
    roles: Array<AccountMemberRole>;
    deletedAt?: string | null;
    member: {
      __typename?: 'User';
      tz: string;
      lang: LanguageType;
      fmtNum: NumberFormatType;
      fmtDate: DateFormatType;
      fmtTime: TimeFormatType;
      isAdmin?: boolean | null;
      isSuperAdmin?: boolean | null;
      createdAt: string;
      disabledAt?: string | null;
      deletedAt?: string | null;
      id: string;
      fullName?: string | null;
      email: string;
      phone?: any | null;
    };
  }>;
  invitations: Array<{
    __typename?: 'AccountInvitation';
    id: string;
    email: any;
    roles: Array<AccountMemberRole>;
    expiresAfter: string;
    invitedBy: string;
    deletedAt?: string | null;
    inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
  }>;
};

export type AddressFragment = {
  __typename?: 'Address';
  id?: string | null;
  street1?: string | null;
  street2?: string | null;
  city: string;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
};

export type CommentFragment = {
  __typename?: 'Comment';
  id: string;
  comment: string;
  createdAt: string;
  createdBy?: string | null;
  creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
};

export type ContactFragment = {
  __typename?: 'Contact';
  id: string;
  role: ContactRole;
  name: string;
  email?: string | null;
  phone?: string | null;
  company?: string | null;
  companyNo?: string | null;
  taxId?: string | null;
  note?: string | null;
  address?: {
    __typename?: 'Address';
    id?: string | null;
    street1?: string | null;
    street2?: string | null;
    city: string;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
  } | null;
};

export type ContractBaseFragment = { __typename?: 'Contract'; id: string; title: string };

export type ContractListFragment = {
  __typename?: 'Contract';
  id: string;
  contractHid?: string | null;
  title: string;
  note: string;
  signingDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  terminationDate?: string | null;
  terminationReason?: string | null;
  deletedAt?: string | null;
  createdAt: string;
  canManage: boolean;
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    role: ContactRole;
    name: string;
    email?: string | null;
    phone?: string | null;
    company?: string | null;
    companyNo?: string | null;
    taxId?: string | null;
    note?: string | null;
    address?: {
      __typename?: 'Address';
      id?: string | null;
      street1?: string | null;
      street2?: string | null;
      city: string;
      state?: string | null;
      zip?: string | null;
      country?: string | null;
    } | null;
  }>;
  mainUnit?: {
    __typename?: 'Unit';
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  } | null;
};

export type ContractFragment = {
  __typename?: 'Contract';
  id: string;
  contractHid?: string | null;
  title: string;
  note: string;
  signingDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  terminationDate?: string | null;
  terminationReason?: string | null;
  deletedAt?: string | null;
  createdAt: string;
  canManage: boolean;
  mainUnit?: {
    __typename?: 'Unit';
    description: string;
    note: string;
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    photos: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    unitFiles: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    filesForTenant: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    tasks: Array<{
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    expenses: Array<{
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    }>;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  } | null;
  units: Array<{
    __typename?: 'Unit';
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  }>;
  files: Array<{
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  }>;
  comments: Array<{
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  documents: Array<{
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    title: string;
    description?: string | null;
    content: unknown;
    tags: Array<string>;
    unitId?: string | null;
    contractId?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    signedOffByTenantAt?: string | null;
    signedOffByManagerAt?: string | null;
    tenantUserId?: string | null;
    managerUserId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  contacts: Array<{
    __typename?: 'Contact';
    id: string;
    role: ContactRole;
    name: string;
    email?: string | null;
    phone?: string | null;
    company?: string | null;
    companyNo?: string | null;
    taxId?: string | null;
    note?: string | null;
    address?: {
      __typename?: 'Address';
      id?: string | null;
      street1?: string | null;
      street2?: string | null;
      city: string;
      state?: string | null;
      zip?: string | null;
      country?: string | null;
    } | null;
  }>;
};

export type DocumentFragment = {
  __typename?: 'Document';
  id: string;
  type: DocumentType;
  title: string;
  description?: string | null;
  content: unknown;
  tags: Array<string>;
  unitId?: string | null;
  contractId?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  signedOffByTenantAt?: string | null;
  signedOffByManagerAt?: string | null;
  tenantUserId?: string | null;
  managerUserId?: string | null;
  unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
  contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
};

export type ExpensePaymentFragmentFragment = {
  __typename?: 'ExpensePayment';
  id: string;
  accountId: string;
  transactionId: string;
  expenseId: string;
  amount: number;
  createdAt: string;
  createdBy?: string | null;
  deletedAt?: string | null;
  expense?: { __typename?: 'Expense'; id: string; title: string } | null;
};

export type ExpenseUnitAssignmentFragmentFragment = {
  __typename?: 'ExpenseUnitAssignment';
  unitId: string;
  expenseId: string;
  amount: number;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
};

export type ExpenseFragment = {
  __typename?: 'Expense';
  id: string;
  accountId: string;
  title: string;
  amount: number;
  taxDeductible: number;
  date: string;
  dueDate: string;
  refNo?: string | null;
  paidAt?: string | null;
  paidAmount: number;
  isCost?: boolean | null;
  createdAt: string;
  modifiedAt: string;
  modifiedBy: string;
  deletedAt?: string | null;
  deletedBy?: string | null;
  comments: Array<{
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  payments: Array<{
    __typename?: 'ExpensePayment';
    id: string;
    accountId: string;
    transactionId: string;
    expenseId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    expense?: { __typename?: 'Expense'; id: string; title: string } | null;
  }>;
  unitAssignments: Array<{
    __typename?: 'ExpenseUnitAssignment';
    unitId: string;
    expenseId: string;
    amount: number;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  }>;
};

export type FileRefUploadPayloadFragment = { __typename?: 'FileRefUploadPayload'; uploadUrl: string; fileId: string };

export type FileRefFragment = {
  __typename?: 'FileRef';
  id: string;
  name?: string | null;
  desc?: string | null;
  tags: Array<string>;
  url: string;
  urlXs?: string | null;
  urlMd?: string | null;
  mimeType: string;
  size: number;
  uploadedAt?: string | null;
  deletedAt?: string | null;
};

export type InvoicePaymentFragmentFragment = {
  __typename?: 'InvoicePayment';
  id: string;
  accountId: string;
  transactionId: string;
  invoiceId: string;
  amount: number;
  createdAt: string;
  createdBy?: string | null;
  deletedAt?: string | null;
  invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
};

export type InvoiceUnitAssignmentFragmentFragment = {
  __typename?: 'InvoiceUnitAssignment';
  unitId: string;
  invoiceId: string;
  amount: number;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
};

export type InvoiceFragment = {
  __typename?: 'Invoice';
  id: string;
  accountId: string;
  contractId: string;
  invoiceNo?: string | null;
  refNo?: string | null;
  description?: string | null;
  totalAmount: number;
  paidAmount: number;
  isDraft: boolean;
  issuedAt?: string | null;
  dueDate: string;
  paidAt?: string | null;
  createdAt: string;
  deletedAt?: string | null;
  rows: Array<{
    __typename?: 'InvoiceRow';
    rowNumber: number;
    text: string;
    unit: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    price: number;
  }>;
  comments: Array<{
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  contract?: {
    __typename?: 'Contract';
    unitIds: Array<string>;
    id: string;
    title: string;
    units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
  } | null;
  payments: Array<{
    __typename?: 'InvoicePayment';
    id: string;
    accountId: string;
    transactionId: string;
    invoiceId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
  }>;
  unitAssignments: Array<{
    __typename?: 'InvoiceUnitAssignment';
    unitId: string;
    invoiceId: string;
    amount: number;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  }>;
};

export type MoneyTransactionFragmentFragment = {
  __typename?: 'MoneyTransaction';
  id: string;
  accountId: string;
  createdAt: string;
  createdBy?: string | null;
  transactionDate: string;
  type: TransactionType;
  value: number;
  cash: boolean;
  bankAccountNo: string;
  otherAccountNo?: string | null;
  note?: string | null;
  reconciledValue: number;
  reference?: string | null;
  doNotReconcile?: boolean | null;
  deletedAt?: string | null;
  invoicePayments: Array<{
    __typename?: 'InvoicePayment';
    id: string;
    accountId: string;
    transactionId: string;
    invoiceId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
  }>;
  expensePayments: Array<{
    __typename?: 'ExpensePayment';
    id: string;
    accountId: string;
    transactionId: string;
    expenseId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    expense?: { __typename?: 'Expense'; id: string; title: string } | null;
  }>;
};

export type UnitBaseFragment = {
  __typename?: 'Unit';
  id: string;
  accountId: string;
  name: string;
  status: UnitStatus;
  deletedAt?: string | null;
  canManage: boolean;
};

export type UnitListFragment = {
  __typename?: 'Unit';
  address: string;
  id: string;
  accountId: string;
  name: string;
  status: UnitStatus;
  deletedAt?: string | null;
  canManage: boolean;
  coverPhoto?: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  } | null;
};

export type UnitFragment = {
  __typename?: 'Unit';
  description: string;
  note: string;
  address: string;
  id: string;
  accountId: string;
  name: string;
  status: UnitStatus;
  deletedAt?: string | null;
  canManage: boolean;
  photos: Array<{
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  }>;
  unitFiles: Array<{
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  }>;
  filesForTenant: Array<{
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  }>;
  comments: Array<{
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  tasks: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  }>;
  documents: Array<{
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    title: string;
    description?: string | null;
    content: unknown;
    tags: Array<string>;
    unitId?: string | null;
    contractId?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    signedOffByTenantAt?: string | null;
    signedOffByManagerAt?: string | null;
    tenantUserId?: string | null;
    managerUserId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  expenses: Array<{
    __typename?: 'Expense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    date: string;
    dueDate: string;
    refNo?: string | null;
    paidAt?: string | null;
    paidAmount: number;
    isCost?: boolean | null;
    createdAt: string;
    modifiedAt: string;
    modifiedBy: string;
    deletedAt?: string | null;
    deletedBy?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    payments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'ExpenseUnitAssignment';
      unitId: string;
      expenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
  coverPhoto?: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  } | null;
};

export type RecurringExpenseUnitAssignmentFragmentFragment = {
  __typename?: 'RecurringExpenseUnitAssignment';
  unitId: string;
  recExpenseId: string;
  amount: number;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
};

export type RecurringExpenseFragmentFragment = {
  __typename?: 'RecurringExpense';
  id: string;
  accountId: string;
  title: string;
  amount: number;
  taxDeductible: number;
  refNo?: string | null;
  nextDate: string;
  frequency: RecurringExpenseFrequency;
  stopAfterDate?: string | null;
  dueDays: number;
  suspended: boolean;
  createdAt: string;
  deletedAt?: string | null;
  unitAssignments: Array<{
    __typename?: 'RecurringExpenseUnitAssignment';
    unitId: string;
    recExpenseId: string;
    amount: number;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  }>;
};

export type RecurringInvoiceUnitAssignmentFragmentFragment = {
  __typename?: 'RecurringInvoiceUnitAssignment';
  unitId: string;
  recInvoiceId: string;
  amount: number;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
};

export type RecurringInvoiceFragmentFragment = {
  __typename?: 'RecurringInvoice';
  id: string;
  accountId: string;
  contractId: string;
  nextDate: string;
  frequency: RecurringInvoiceFrequency;
  stopAfterDate?: string | null;
  dueDays: number;
  description: string;
  totalAmount: number;
  suspended: boolean;
  createdAt: string;
  deletedAt?: string | null;
  rows: Array<{
    __typename?: 'RecurringInvoiceRow';
    rowNumber: number;
    text: string;
    unit: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    price: number;
  }>;
  contract?: {
    __typename?: 'Contract';
    id: string;
    title: string;
    unitIds: Array<string>;
    units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
  } | null;
  unitAssignments: Array<{
    __typename?: 'RecurringInvoiceUnitAssignment';
    unitId: string;
    recInvoiceId: string;
    amount: number;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  }>;
};

export type RecurringTaskFragmentFragment = {
  __typename?: 'RecurringTask';
  id: string;
  title: string;
  nextDate: string;
  dueDays: number;
  frequency: RecurringTaskFrequency;
  stopAfterDate?: string | null;
  description?: string | null;
  suspended?: boolean | null;
  createdAt: string;
  deletedAt?: string | null;
  accountId: string;
  unitId?: string | null;
  contractId?: string | null;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  contract?: { __typename?: 'Contract'; id: string; title: string } | null;
};

export type RequestErrorFragment = { __typename?: 'RequestError'; code: any; field?: any | null };

export type TaskListFragment = {
  __typename?: 'Task';
  id: string;
  title: string;
  description?: string | null;
  status: TaskStatus;
  startDate?: string | null;
  dueDate?: string | null;
  completedAt?: string | null;
  assignedTo?: string | null;
  unitId?: string | null;
  contractId?: string | null;
  accountId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  lastComment?: {
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  } | null;
};

export type TaskFragment = {
  __typename?: 'Task';
  id: string;
  title: string;
  description?: string | null;
  status: TaskStatus;
  startDate?: string | null;
  dueDate?: string | null;
  completedAt?: string | null;
  assignedTo?: string | null;
  unitId?: string | null;
  contractId?: string | null;
  accountId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  comments: Array<{
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  }>;
  unit?: { __typename?: 'Unit'; id: string; name: string } | null;
  contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  lastComment?: {
    __typename?: 'Comment';
    id: string;
    comment: string;
    createdAt: string;
    createdBy?: string | null;
    creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
  } | null;
};

export type UserBaseFragment = {
  __typename?: 'User';
  id: string;
  fullName?: string | null;
  email: string;
  phone?: any | null;
};

export type UserFragment = {
  __typename?: 'User';
  tz: string;
  lang: LanguageType;
  fmtNum: NumberFormatType;
  fmtDate: DateFormatType;
  fmtTime: TimeFormatType;
  isAdmin?: boolean | null;
  isSuperAdmin?: boolean | null;
  createdAt: string;
  disabledAt?: string | null;
  deletedAt?: string | null;
  id: string;
  fullName?: string | null;
  email: string;
  phone?: any | null;
};

export type CreateInvoicePaymentMutationVariables = Exact<{
  input: CreateInvoicePaymentInput;
}>;

export type CreateInvoicePaymentMutation = {
  __typename?: 'Mutation';
  createInvoicePayment: {
    __typename?: 'InvoicePaymentPayload';
    invoicePayment?: {
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteInvoicePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteInvoicePaymentMutation = {
  __typename?: 'Mutation';
  deleteInvoicePayment: {
    __typename?: 'InvoicePaymentPayload';
    invoicePayment?: {
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetInvoicePaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetInvoicePaymentQuery = {
  __typename?: 'Query';
  getInvoicePayment?: {
    __typename?: 'InvoicePayment';
    id: string;
    accountId: string;
    transactionId: string;
    invoiceId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
  } | null;
};

export type GetInvoicePaymentsForTransactionQueryVariables = Exact<{
  transactionId: Scalars['ID']['input'];
}>;

export type GetInvoicePaymentsForTransactionQuery = {
  __typename?: 'Query';
  getInvoicePaymentsForTransaction: Array<{
    __typename?: 'InvoicePayment';
    id: string;
    accountId: string;
    transactionId: string;
    invoiceId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
  }>;
};

export type GetInvoicePaymentsForInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type GetInvoicePaymentsForInvoiceQuery = {
  __typename?: 'Query';
  getInvoicePaymentsForInvoice: Array<{
    __typename?: 'InvoicePayment';
    id: string;
    accountId: string;
    transactionId: string;
    invoiceId: string;
    amount: number;
    createdAt: string;
    createdBy?: string | null;
    deletedAt?: string | null;
    invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
  }>;
};

export type GetUnpaidInvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnpaidInvoicesQuery = {
  __typename?: 'Query';
  getUnpaidInvoices: Array<{
    __typename?: 'Invoice';
    id: string;
    accountId: string;
    contractId: string;
    invoiceNo?: string | null;
    refNo?: string | null;
    description?: string | null;
    totalAmount: number;
    paidAmount: number;
    isDraft: boolean;
    issuedAt?: string | null;
    dueDate: string;
    paidAt?: string | null;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'InvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contract?: {
      __typename?: 'Contract';
      unitIds: Array<string>;
      id: string;
      title: string;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    payments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'InvoiceUnitAssignment';
      unitId: string;
      invoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;

export type CreateInvoiceMutation = {
  __typename?: 'Mutation';
  createInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
}>;

export type UpdateInvoiceMutation = {
  __typename?: 'Mutation';
  updateInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type DeleteInvoiceMutation = {
  __typename?: 'Mutation';
  deleteInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type UndeleteInvoiceMutation = {
  __typename?: 'Mutation';
  undeleteInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MarkInvoicePaidMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
}>;

export type MarkInvoicePaidMutation = {
  __typename?: 'Mutation';
  markInvoicePaid: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MarkInvoiceUnpaidMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type MarkInvoiceUnpaidMutation = {
  __typename?: 'Mutation';
  markInvoiceUnpaid: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type CopyInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type CopyInvoiceMutation = {
  __typename?: 'Mutation';
  copyInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddInvoiceCommentMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: CreateCommentInput;
}>;

export type AddInvoiceCommentMutation = {
  __typename?: 'Mutation';
  addInvoiceComment?: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type UpdateInvoiceCommentMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;

export type UpdateInvoiceCommentMutation = {
  __typename?: 'Mutation';
  updateInvoiceComment?: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type RemoveInvoiceCommentMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;

export type RemoveInvoiceCommentMutation = {
  __typename?: 'Mutation';
  removeInvoiceComment?: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type AddInvoiceRowMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: InvoiceRowInput;
}>;

export type AddInvoiceRowMutation = {
  __typename?: 'Mutation';
  addInvoiceRow: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateInvoiceRowMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
  input: InvoiceRowInput;
}>;

export type UpdateInvoiceRowMutation = {
  __typename?: 'Mutation';
  updateInvoiceRow: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveInvoiceRowMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type RemoveInvoiceRowMutation = {
  __typename?: 'Mutation';
  removeInvoiceRow: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MoveInvoiceRowUpMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type MoveInvoiceRowUpMutation = {
  __typename?: 'Mutation';
  moveInvoiceRowUp: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MoveInvoiceRowDownMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type MoveInvoiceRowDownMutation = {
  __typename?: 'Mutation';
  moveInvoiceRowDown: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SendPaymentConfirmationMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type SendPaymentConfirmationMutation = {
  __typename?: 'Mutation';
  sendPaymentConfirmation: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SendInvoiceInformationEmailMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  emails?: InputMaybe<Scalars['String']['input']>;
  includeDefaultRecipients: Scalars['Boolean']['input'];
}>;

export type SendInvoiceInformationEmailMutation = {
  __typename?: 'Mutation';
  sendInvoiceInformationEmail: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type IssueInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;

export type IssueInvoiceMutation = {
  __typename?: 'Mutation';
  issueInvoice: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SetInvoiceUnitAssignmentsMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  assignments: Array<InvoiceUnitAssignmentInput> | InvoiceUnitAssignmentInput;
}>;

export type SetInvoiceUnitAssignmentsMutation = {
  __typename?: 'Mutation';
  setInvoiceUnitAssignments: {
    __typename?: 'InvoicePayload';
    invoice?: {
      __typename?: 'Invoice';
      id: string;
      accountId: string;
      contractId: string;
      invoiceNo?: string | null;
      refNo?: string | null;
      description?: string | null;
      totalAmount: number;
      paidAmount: number;
      isDraft: boolean;
      issuedAt?: string | null;
      dueDate: string;
      paidAt?: string | null;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'InvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      contract?: {
        __typename?: 'Contract';
        unitIds: Array<string>;
        id: string;
        title: string;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      payments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'InvoiceUnitAssignment';
        unitId: string;
        invoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetInvoiceQuery = {
  __typename?: 'Query';
  getInvoice?: {
    __typename?: 'Invoice';
    id: string;
    accountId: string;
    contractId: string;
    invoiceNo?: string | null;
    refNo?: string | null;
    description?: string | null;
    totalAmount: number;
    paidAmount: number;
    isDraft: boolean;
    issuedAt?: string | null;
    dueDate: string;
    paidAt?: string | null;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'InvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contract?: {
      __typename?: 'Contract';
      unitIds: Array<string>;
      id: string;
      title: string;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    payments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'InvoiceUnitAssignment';
      unitId: string;
      invoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  } | null;
};

export type GetInvoicesForContractQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type GetInvoicesForContractQuery = {
  __typename?: 'Query';
  getInvoicesForContract: Array<{
    __typename?: 'Invoice';
    id: string;
    accountId: string;
    contractId: string;
    invoiceNo?: string | null;
    refNo?: string | null;
    description?: string | null;
    totalAmount: number;
    paidAmount: number;
    isDraft: boolean;
    issuedAt?: string | null;
    dueDate: string;
    paidAt?: string | null;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'InvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contract?: {
      __typename?: 'Contract';
      unitIds: Array<string>;
      id: string;
      title: string;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    payments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'InvoiceUnitAssignment';
      unitId: string;
      invoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type GetInvoicesForAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvoicesForAccountQuery = {
  __typename?: 'Query';
  getInvoicesForAccount: Array<{
    __typename?: 'Invoice';
    id: string;
    accountId: string;
    contractId: string;
    invoiceNo?: string | null;
    refNo?: string | null;
    description?: string | null;
    totalAmount: number;
    paidAmount: number;
    isDraft: boolean;
    issuedAt?: string | null;
    dueDate: string;
    paidAt?: string | null;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'InvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    contract?: {
      __typename?: 'Contract';
      unitIds: Array<string>;
      id: string;
      title: string;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    payments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    unitAssignments: Array<{
      __typename?: 'InvoiceUnitAssignment';
      unitId: string;
      invoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type CreateMoneyTransactionMutationVariables = Exact<{
  input: CreateMoneyTransactionInput;
}>;

export type CreateMoneyTransactionMutation = {
  __typename?: 'Mutation';
  createMoneyTransaction: {
    __typename?: 'MoneyTransactionPayload';
    moneyTransaction?: {
      __typename?: 'MoneyTransaction';
      id: string;
      accountId: string;
      createdAt: string;
      createdBy?: string | null;
      transactionDate: string;
      type: TransactionType;
      value: number;
      cash: boolean;
      bankAccountNo: string;
      otherAccountNo?: string | null;
      note?: string | null;
      reconciledValue: number;
      reference?: string | null;
      doNotReconcile?: boolean | null;
      deletedAt?: string | null;
      invoicePayments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      expensePayments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateMoneyTransactionMutationVariables = Exact<{
  input: UpdateMoneyTransactionInput;
}>;

export type UpdateMoneyTransactionMutation = {
  __typename?: 'Mutation';
  updateMoneyTransaction: {
    __typename?: 'MoneyTransactionPayload';
    moneyTransaction?: {
      __typename?: 'MoneyTransaction';
      id: string;
      accountId: string;
      createdAt: string;
      createdBy?: string | null;
      transactionDate: string;
      type: TransactionType;
      value: number;
      cash: boolean;
      bankAccountNo: string;
      otherAccountNo?: string | null;
      note?: string | null;
      reconciledValue: number;
      reference?: string | null;
      doNotReconcile?: boolean | null;
      deletedAt?: string | null;
      invoicePayments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      expensePayments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteMoneyTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMoneyTransactionMutation = {
  __typename?: 'Mutation';
  deleteMoneyTransaction: {
    __typename?: 'MoneyTransactionPayload';
    moneyTransaction?: {
      __typename?: 'MoneyTransaction';
      id: string;
      accountId: string;
      createdAt: string;
      createdBy?: string | null;
      transactionDate: string;
      type: TransactionType;
      value: number;
      cash: boolean;
      bankAccountNo: string;
      otherAccountNo?: string | null;
      note?: string | null;
      reconciledValue: number;
      reference?: string | null;
      doNotReconcile?: boolean | null;
      deletedAt?: string | null;
      invoicePayments: Array<{
        __typename?: 'InvoicePayment';
        id: string;
        accountId: string;
        transactionId: string;
        invoiceId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
      }>;
      expensePayments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetMoneyTransactionsForAccountQueryVariables = Exact<{
  filter?: InputMaybe<MoneyTransactionFilterInput>;
}>;

export type GetMoneyTransactionsForAccountQuery = {
  __typename?: 'Query';
  getMoneyTransactionsForAccount: Array<{
    __typename?: 'MoneyTransaction';
    id: string;
    accountId: string;
    createdAt: string;
    createdBy?: string | null;
    transactionDate: string;
    type: TransactionType;
    value: number;
    cash: boolean;
    bankAccountNo: string;
    otherAccountNo?: string | null;
    note?: string | null;
    reconciledValue: number;
    reference?: string | null;
    doNotReconcile?: boolean | null;
    deletedAt?: string | null;
    invoicePayments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    expensePayments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
  }>;
};

export type GetMoneyTransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMoneyTransactionQuery = {
  __typename?: 'Query';
  getMoneyTransaction?: {
    __typename?: 'MoneyTransaction';
    id: string;
    accountId: string;
    createdAt: string;
    createdBy?: string | null;
    transactionDate: string;
    type: TransactionType;
    value: number;
    cash: boolean;
    bankAccountNo: string;
    otherAccountNo?: string | null;
    note?: string | null;
    reconciledValue: number;
    reference?: string | null;
    doNotReconcile?: boolean | null;
    deletedAt?: string | null;
    invoicePayments: Array<{
      __typename?: 'InvoicePayment';
      id: string;
      accountId: string;
      transactionId: string;
      invoiceId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      invoice?: { __typename?: 'Invoice'; id: string; invoiceNo?: string | null } | null;
    }>;
    expensePayments: Array<{
      __typename?: 'ExpensePayment';
      id: string;
      accountId: string;
      transactionId: string;
      expenseId: string;
      amount: number;
      createdAt: string;
      createdBy?: string | null;
      deletedAt?: string | null;
      expense?: { __typename?: 'Expense'; id: string; title: string } | null;
    }>;
  } | null;
};

export type UpdateNotificationSettingsMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: UpdateNotificationSettingsInput;
}>;

export type UpdateNotificationSettingsMutation = {
  __typename?: 'Mutation';
  updateNotificationSettings: {
    __typename?: 'NotificationSettingsPayload';
    notificationSettings?: {
      __typename?: 'NotificationSettings';
      id: string;
      accountId: string;
      paymentConfirmationEnabled: boolean;
      paymentConfirmationSubject?: string | null;
      paymentConfirmationText?: string | null;
      invoiceInformationSubject?: string | null;
      invoiceInformationText?: string | null;
      notificationBccEmails?: string | null;
      createdAt: string;
      updatedAt: string;
      notifications: Array<{
        __typename?: 'Notification';
        id: string;
        daysBefore: number;
        subject: string;
        text: string;
        active: boolean;
        createdAt: string;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetNotificationSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type GetNotificationSettingsQuery = {
  __typename?: 'Query';
  getNotificationSettings?: {
    __typename?: 'NotificationSettings';
    id: string;
    accountId: string;
    paymentConfirmationEnabled: boolean;
    paymentConfirmationSubject?: string | null;
    paymentConfirmationText?: string | null;
    invoiceInformationSubject?: string | null;
    invoiceInformationText?: string | null;
    notificationBccEmails?: string | null;
    createdAt: string;
    updatedAt: string;
    notifications: Array<{
      __typename?: 'Notification';
      id: string;
      daysBefore: number;
      subject: string;
      text: string;
      active: boolean;
      createdAt: string;
    }>;
  } | null;
};

export type CreateRecurringExpenseMutationVariables = Exact<{
  input: CreateRecurringExpenseInput;
}>;

export type CreateRecurringExpenseMutation = {
  __typename?: 'Mutation';
  createRecurringExpense: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateRecurringExpenseMutationVariables = Exact<{
  input: UpdateRecurringExpenseInput;
}>;

export type UpdateRecurringExpenseMutation = {
  __typename?: 'Mutation';
  updateRecurringExpense: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteRecurringExpenseMutationVariables = Exact<{
  recurringExpenseId: Scalars['ID']['input'];
}>;

export type DeleteRecurringExpenseMutation = {
  __typename?: 'Mutation';
  deleteRecurringExpense: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SuspendRecurringExpenseMutationVariables = Exact<{
  recurringExpenseId: Scalars['ID']['input'];
}>;

export type SuspendRecurringExpenseMutation = {
  __typename?: 'Mutation';
  suspendRecurringExpense: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnsuspendRecurringExpenseMutationVariables = Exact<{
  recurringExpenseId: Scalars['ID']['input'];
}>;

export type UnsuspendRecurringExpenseMutation = {
  __typename?: 'Mutation';
  unsuspendRecurringExpense: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SetRecurringExpenseUnitAssignmentsMutationVariables = Exact<{
  recurringExpenseId: Scalars['ID']['input'];
  assignments: Array<RecurringExpenseUnitAssignmentInput> | RecurringExpenseUnitAssignmentInput;
}>;

export type SetRecurringExpenseUnitAssignmentsMutation = {
  __typename?: 'Mutation';
  setRecurringExpenseUnitAssignments: {
    __typename?: 'RecurringExpensePayload';
    recurringExpense?: {
      __typename?: 'RecurringExpense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      refNo?: string | null;
      nextDate: string;
      frequency: RecurringExpenseFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      unitAssignments: Array<{
        __typename?: 'RecurringExpenseUnitAssignment';
        unitId: string;
        recExpenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetRecurringExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRecurringExpenseQuery = {
  __typename?: 'Query';
  getRecurringExpense?: {
    __typename?: 'RecurringExpense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    refNo?: string | null;
    nextDate: string;
    frequency: RecurringExpenseFrequency;
    stopAfterDate?: string | null;
    dueDays: number;
    suspended: boolean;
    createdAt: string;
    deletedAt?: string | null;
    unitAssignments: Array<{
      __typename?: 'RecurringExpenseUnitAssignment';
      unitId: string;
      recExpenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  } | null;
};

export type GetRecurringExpensesForAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecurringExpensesForAccountQuery = {
  __typename?: 'Query';
  getRecurringExpensesForAccount: Array<{
    __typename?: 'RecurringExpense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    refNo?: string | null;
    nextDate: string;
    frequency: RecurringExpenseFrequency;
    stopAfterDate?: string | null;
    dueDays: number;
    suspended: boolean;
    createdAt: string;
    deletedAt?: string | null;
    unitAssignments: Array<{
      __typename?: 'RecurringExpenseUnitAssignment';
      unitId: string;
      recExpenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type GetRecurringExpensesForUnitQueryVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type GetRecurringExpensesForUnitQuery = {
  __typename?: 'Query';
  getRecurringExpensesForUnit: Array<{
    __typename?: 'RecurringExpense';
    id: string;
    accountId: string;
    title: string;
    amount: number;
    taxDeductible: number;
    refNo?: string | null;
    nextDate: string;
    frequency: RecurringExpenseFrequency;
    stopAfterDate?: string | null;
    dueDays: number;
    suspended: boolean;
    createdAt: string;
    deletedAt?: string | null;
    unitAssignments: Array<{
      __typename?: 'RecurringExpenseUnitAssignment';
      unitId: string;
      recExpenseId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type CreateRecurringInvoiceMutationVariables = Exact<{
  input: CreateRecurringInvoiceInput;
}>;

export type CreateRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  createRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateRecurringInvoiceMutationVariables = Exact<{
  input: UpdateRecurringInvoiceInput;
}>;

export type UpdateRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  updateRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteRecurringInvoiceMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
}>;

export type DeleteRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  deleteRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteRecurringInvoiceMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
}>;

export type UndeleteRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  undeleteRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SuspendRecurringInvoiceMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
}>;

export type SuspendRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  suspendRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnsuspendRecurringInvoiceMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
}>;

export type UnsuspendRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  unsuspendRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type CopyRecurringInvoiceMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
}>;

export type CopyRecurringInvoiceMutation = {
  __typename?: 'Mutation';
  copyRecurringInvoice: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddRecurringInvoiceRowMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  input: RecurringInvoiceRowInput;
}>;

export type AddRecurringInvoiceRowMutation = {
  __typename?: 'Mutation';
  addRecurringInvoiceRow: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateRecurringInvoiceRowMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
  input: RecurringInvoiceRowInput;
}>;

export type UpdateRecurringInvoiceRowMutation = {
  __typename?: 'Mutation';
  updateRecurringInvoiceRow: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type RemoveRecurringInvoiceRowMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type RemoveRecurringInvoiceRowMutation = {
  __typename?: 'Mutation';
  removeRecurringInvoiceRow: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MoveRecurringInvoiceRowUpMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type MoveRecurringInvoiceRowUpMutation = {
  __typename?: 'Mutation';
  moveRecurringInvoiceRowUp: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type MoveRecurringInvoiceRowDownMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  rowNumber: Scalars['Int']['input'];
}>;

export type MoveRecurringInvoiceRowDownMutation = {
  __typename?: 'Mutation';
  moveRecurringInvoiceRowDown: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SetRecurringInvoiceUnitAssignmentsMutationVariables = Exact<{
  recurringInvoiceId: Scalars['ID']['input'];
  assignments: Array<RecurringInvoiceUnitAssignmentInput> | RecurringInvoiceUnitAssignmentInput;
}>;

export type SetRecurringInvoiceUnitAssignmentsMutation = {
  __typename?: 'Mutation';
  setRecurringInvoiceUnitAssignments: {
    __typename?: 'RecurringInvoicePayload';
    recurringInvoice?: {
      __typename?: 'RecurringInvoice';
      id: string;
      accountId: string;
      contractId: string;
      nextDate: string;
      frequency: RecurringInvoiceFrequency;
      stopAfterDate?: string | null;
      dueDays: number;
      description: string;
      totalAmount: number;
      suspended: boolean;
      createdAt: string;
      deletedAt?: string | null;
      rows: Array<{
        __typename?: 'RecurringInvoiceRow';
        rowNumber: number;
        text: string;
        unit: string;
        quantity: number;
        unitPrice: number;
        discount: number;
        price: number;
      }>;
      contract?: {
        __typename?: 'Contract';
        id: string;
        title: string;
        unitIds: Array<string>;
        units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
      } | null;
      unitAssignments: Array<{
        __typename?: 'RecurringInvoiceUnitAssignment';
        unitId: string;
        recInvoiceId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetRecurringInvoicesForContractQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type GetRecurringInvoicesForContractQuery = {
  __typename?: 'Query';
  getRecurringInvoicesForContract: Array<{
    __typename?: 'RecurringInvoice';
    id: string;
    accountId: string;
    contractId: string;
    nextDate: string;
    frequency: RecurringInvoiceFrequency;
    stopAfterDate?: string | null;
    dueDays: number;
    description: string;
    totalAmount: number;
    suspended: boolean;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'RecurringInvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    contract?: {
      __typename?: 'Contract';
      id: string;
      title: string;
      unitIds: Array<string>;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    unitAssignments: Array<{
      __typename?: 'RecurringInvoiceUnitAssignment';
      unitId: string;
      recInvoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  }>;
};

export type GetRecurringInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRecurringInvoiceQuery = {
  __typename?: 'Query';
  getRecurringInvoice?: {
    __typename?: 'RecurringInvoice';
    id: string;
    accountId: string;
    contractId: string;
    nextDate: string;
    frequency: RecurringInvoiceFrequency;
    stopAfterDate?: string | null;
    dueDays: number;
    description: string;
    totalAmount: number;
    suspended: boolean;
    createdAt: string;
    deletedAt?: string | null;
    rows: Array<{
      __typename?: 'RecurringInvoiceRow';
      rowNumber: number;
      text: string;
      unit: string;
      quantity: number;
      unitPrice: number;
      discount: number;
      price: number;
    }>;
    contract?: {
      __typename?: 'Contract';
      id: string;
      title: string;
      unitIds: Array<string>;
      units: Array<{ __typename?: 'Unit'; id: string; name: string }>;
    } | null;
    unitAssignments: Array<{
      __typename?: 'RecurringInvoiceUnitAssignment';
      unitId: string;
      recInvoiceId: string;
      amount: number;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    }>;
  } | null;
};

export type CreateRecurringTaskMutationVariables = Exact<{
  input: CreateRecurringTaskInput;
}>;

export type CreateRecurringTaskMutation = {
  __typename?: 'Mutation';
  createRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateRecurringTaskMutationVariables = Exact<{
  recurringTaskId: Scalars['ID']['input'];
  input: UpdateRecurringTaskInput;
}>;

export type UpdateRecurringTaskMutation = {
  __typename?: 'Mutation';
  updateRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteRecurringTaskMutationVariables = Exact<{
  recurringTaskId: Scalars['ID']['input'];
}>;

export type DeleteRecurringTaskMutation = {
  __typename?: 'Mutation';
  deleteRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteRecurringTaskMutationVariables = Exact<{
  recurringTaskId: Scalars['ID']['input'];
}>;

export type UndeleteRecurringTaskMutation = {
  __typename?: 'Mutation';
  undeleteRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SuspendRecurringTaskMutationVariables = Exact<{
  recurringTaskId: Scalars['ID']['input'];
}>;

export type SuspendRecurringTaskMutation = {
  __typename?: 'Mutation';
  suspendRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnsuspendRecurringTaskMutationVariables = Exact<{
  recurringTaskId: Scalars['ID']['input'];
}>;

export type UnsuspendRecurringTaskMutation = {
  __typename?: 'Mutation';
  unsuspendRecurringTask: {
    __typename?: 'RecurringTaskPayload';
    recurringTask?: {
      __typename?: 'RecurringTask';
      id: string;
      title: string;
      nextDate: string;
      dueDays: number;
      frequency: RecurringTaskFrequency;
      stopAfterDate?: string | null;
      description?: string | null;
      suspended?: boolean | null;
      createdAt: string;
      deletedAt?: string | null;
      accountId: string;
      unitId?: string | null;
      contractId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetRecurringTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRecurringTaskQuery = {
  __typename?: 'Query';
  getRecurringTask?: {
    __typename?: 'RecurringTask';
    id: string;
    title: string;
    nextDate: string;
    dueDays: number;
    frequency: RecurringTaskFrequency;
    stopAfterDate?: string | null;
    description?: string | null;
    suspended?: boolean | null;
    createdAt: string;
    deletedAt?: string | null;
    accountId: string;
    unitId?: string | null;
    contractId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  } | null;
};

export type GetRecurringTasksForAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecurringTasksForAccountQuery = {
  __typename?: 'Query';
  getRecurringTasksForAccount: Array<{
    __typename?: 'RecurringTask';
    id: string;
    title: string;
    nextDate: string;
    dueDays: number;
    frequency: RecurringTaskFrequency;
    stopAfterDate?: string | null;
    description?: string | null;
    suspended?: boolean | null;
    createdAt: string;
    deletedAt?: string | null;
    accountId: string;
    unitId?: string | null;
    contractId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  }>;
};

export type GetRecurringTasksForUnitQueryVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type GetRecurringTasksForUnitQuery = {
  __typename?: 'Query';
  getRecurringTasksForUnit: Array<{
    __typename?: 'RecurringTask';
    id: string;
    title: string;
    nextDate: string;
    dueDays: number;
    frequency: RecurringTaskFrequency;
    stopAfterDate?: string | null;
    description?: string | null;
    suspended?: boolean | null;
    createdAt: string;
    deletedAt?: string | null;
    accountId: string;
    unitId?: string | null;
    contractId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  }>;
};

export type GetRecurringTasksForContractQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type GetRecurringTasksForContractQuery = {
  __typename?: 'Query';
  getRecurringTasksForContract: Array<{
    __typename?: 'RecurringTask';
    id: string;
    title: string;
    nextDate: string;
    dueDays: number;
    frequency: RecurringTaskFrequency;
    stopAfterDate?: string | null;
    description?: string | null;
    suspended?: boolean | null;
    createdAt: string;
    deletedAt?: string | null;
    accountId: string;
    unitId?: string | null;
    contractId?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
  }>;
};

export type TaskPayloadFragment = {
  __typename?: 'TaskPayload';
  task?: {
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;

export type CreateTaskMutation = {
  __typename?: 'Mutation';
  createTask: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;

export type UpdateTaskMutation = {
  __typename?: 'Mutation';
  updateTask: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type DeleteTaskMutation = {
  __typename?: 'Mutation';
  deleteTask: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type UndeleteTaskMutation = {
  __typename?: 'Mutation';
  undeleteTask: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddTaskCommentMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: CreateCommentInput;
}>;

export type AddTaskCommentMutation = {
  __typename?: 'Mutation';
  addTaskComment: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateTaskCommentMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;

export type UpdateTaskCommentMutation = {
  __typename?: 'Mutation';
  updateTaskComment: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteTaskCommentMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;

export type DeleteTaskCommentMutation = {
  __typename?: 'Mutation';
  deleteTaskComment: {
    __typename?: 'TaskPayload';
    task?: {
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskQuery = {
  __typename?: 'Query';
  getTask?: {
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  } | null;
};

export type GetTasksQueryVariables = Exact<{ [key: string]: never }>;

export type GetTasksQuery = {
  __typename?: 'Query';
  getTasks: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  }>;
};

export type GetTasksForContractQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;

export type GetTasksForContractQuery = {
  __typename?: 'Query';
  getTasksForContract: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  }>;
};

export type GetTasksForUnitQueryVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type GetTasksForUnitQuery = {
  __typename?: 'Query';
  getTasksForUnit: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatus;
    startDate?: string | null;
    dueDate?: string | null;
    completedAt?: string | null;
    assignedTo?: string | null;
    unitId?: string | null;
    contractId?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    unit?: { __typename?: 'Unit'; id: string; name: string } | null;
    contract?: { __typename?: 'Contract'; id: string; title: string } | null;
    assignee?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    lastComment?: {
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    } | null;
  }>;
};

export type UnitPayloadFragment = {
  __typename?: 'UnitPayload';
  unit?: {
    __typename?: 'Unit';
    description: string;
    note: string;
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    photos: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    unitFiles: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    filesForTenant: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    tasks: Array<{
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    expenses: Array<{
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    }>;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type CreateUnitMutationVariables = Exact<{
  input: CreateUnitInput;
}>;

export type CreateUnitMutation = {
  __typename?: 'Mutation';
  createUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateUnitMutationVariables = Exact<{
  input: UpdateUnitInput;
}>;

export type UpdateUnitMutation = {
  __typename?: 'Mutation';
  updateUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type DeleteUnitMutation = {
  __typename?: 'Mutation';
  deleteUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UndeleteUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type UndeleteUnitMutation = {
  __typename?: 'Mutation';
  undeleteUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type StartRentingUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type StartRentingUnitMutation = {
  __typename?: 'Mutation';
  startRentingUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type StopRentingUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type StopRentingUnitMutation = {
  __typename?: 'Mutation';
  stopRentingUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type ArchiveUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type ArchiveUnitMutation = {
  __typename?: 'Mutation';
  archiveUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UnarchiveUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
}>;

export type UnarchiveUnitMutation = {
  __typename?: 'Mutation';
  unarchiveUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type SetUnitCoverPhotoMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
}>;

export type SetUnitCoverPhotoMutation = {
  __typename?: 'Mutation';
  setUnitCoverPhoto: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type ConfirmUnitPhotoUploadMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
}>;

export type ConfirmUnitPhotoUploadMutation = {
  __typename?: 'Mutation';
  confirmUnitPhotoUpload: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AddUnitPhotoMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  input: FileRefUploadInput;
}>;

export type AddUnitPhotoMutation = {
  __typename?: 'Mutation';
  addUnitPhoto: { __typename?: 'FileRefUploadPayload'; uploadUrl: string; fileId: string };
};

export type DeleteUnitPhotoMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
}>;

export type DeleteUnitPhotoMutation = {
  __typename?: 'Mutation';
  deleteUnitPhoto: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type UpdateUnitPhotoCaptionMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  caption: Scalars['String']['input'];
}>;

export type UpdateUnitPhotoCaptionMutation = {
  __typename?: 'Mutation';
  updateUnitPhotoCaption: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type AddFileToUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  type: FileRefDocType;
  input: FileRefUploadInput;
}>;

export type AddFileToUnitMutation = {
  __typename?: 'Mutation';
  addFileToUnit: { __typename?: 'FileRefUploadPayload'; fileId: string; uploadUrl: string };
};

export type ConfirmFileUploadedToUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
}>;

export type ConfirmFileUploadedToUnitMutation = {
  __typename?: 'Mutation';
  confirmFileUploadedToUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateFileInUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  input: UpdateFileInput;
}>;

export type UpdateFileInUnitMutation = {
  __typename?: 'Mutation';
  updateFileInUnit: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type DeleteFileFromUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;

export type DeleteFileFromUnitMutation = {
  __typename?: 'Mutation';
  deleteFileFromUnit: {
    __typename?: 'FileRef';
    id: string;
    name?: string | null;
    desc?: string | null;
    tags: Array<string>;
    url: string;
    urlXs?: string | null;
    urlMd?: string | null;
    mimeType: string;
    size: number;
    uploadedAt?: string | null;
    deletedAt?: string | null;
  };
};

export type AddUnitCommentMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  input: CreateCommentInput;
}>;

export type AddUnitCommentMutation = {
  __typename?: 'Mutation';
  addUnitComment?: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type UpdateUnitCommentMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;

export type UpdateUnitCommentMutation = {
  __typename?: 'Mutation';
  updateUnitComment?: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type RemoveUnitCommentMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;

export type RemoveUnitCommentMutation = {
  __typename?: 'Mutation';
  removeUnitComment?: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  } | null;
};

export type AddDocumentToUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  input: CreateDocumentInput;
}>;

export type AddDocumentToUnitMutation = {
  __typename?: 'Mutation';
  addDocumentToUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type DeleteDocumentFromUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;

export type DeleteDocumentFromUnitMutation = {
  __typename?: 'Mutation';
  deleteDocumentFromUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type UpdateDocumentInUnitMutationVariables = Exact<{
  unitId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  input: UpdateDocumentInput;
}>;

export type UpdateDocumentInUnitMutation = {
  __typename?: 'Mutation';
  updateDocumentInUnit: {
    __typename?: 'UnitPayload';
    unit?: {
      __typename?: 'Unit';
      description: string;
      note: string;
      address: string;
      id: string;
      accountId: string;
      name: string;
      status: UnitStatus;
      deletedAt?: string | null;
      canManage: boolean;
      photos: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      unitFiles: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      filesForTenant: Array<{
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      }>;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      tasks: Array<{
        __typename?: 'Task';
        id: string;
        title: string;
        description?: string | null;
        status: TaskStatus;
        startDate?: string | null;
        dueDate?: string | null;
        completedAt?: string | null;
        assignedTo?: string | null;
        unitId?: string | null;
        contractId?: string | null;
        accountId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        assignee?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        lastComment?: {
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        } | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        title: string;
        description?: string | null;
        content: unknown;
        tags: Array<string>;
        unitId?: string | null;
        contractId?: string | null;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        signedOffByTenantAt?: string | null;
        signedOffByManagerAt?: string | null;
        tenantUserId?: string | null;
        managerUserId?: string | null;
        unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
        contract?: { __typename?: 'Contract'; id: string; title: string } | null;
        tenant?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
        manager?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      expenses: Array<{
        __typename?: 'Expense';
        id: string;
        accountId: string;
        title: string;
        amount: number;
        taxDeductible: number;
        date: string;
        dueDate: string;
        refNo?: string | null;
        paidAt?: string | null;
        paidAmount: number;
        isCost?: boolean | null;
        createdAt: string;
        modifiedAt: string;
        modifiedBy: string;
        deletedAt?: string | null;
        deletedBy?: string | null;
        comments: Array<{
          __typename?: 'Comment';
          id: string;
          comment: string;
          createdAt: string;
          createdBy?: string | null;
          creator?: {
            __typename?: 'User';
            id: string;
            fullName?: string | null;
            email: string;
            phone?: any | null;
          } | null;
        }>;
        payments: Array<{
          __typename?: 'ExpensePayment';
          id: string;
          accountId: string;
          transactionId: string;
          expenseId: string;
          amount: number;
          createdAt: string;
          createdBy?: string | null;
          deletedAt?: string | null;
          expense?: { __typename?: 'Expense'; id: string; title: string } | null;
        }>;
        unitAssignments: Array<{
          __typename?: 'ExpenseUnitAssignment';
          unitId: string;
          expenseId: string;
          amount: number;
          unit?: { __typename?: 'Unit'; id: string; name: string } | null;
        }>;
      }>;
      coverPhoto?: {
        __typename?: 'FileRef';
        id: string;
        name?: string | null;
        desc?: string | null;
        tags: Array<string>;
        url: string;
        urlXs?: string | null;
        urlMd?: string | null;
        mimeType: string;
        size: number;
        uploadedAt?: string | null;
        deletedAt?: string | null;
      } | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetUnitsQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetUnitsQuery = {
  __typename?: 'Query';
  getUnits: Array<{
    __typename?: 'Unit';
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  }>;
};

export type GetUnitQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetUnitQuery = {
  __typename?: 'Query';
  getUnit?: {
    __typename?: 'Unit';
    description: string;
    note: string;
    address: string;
    id: string;
    accountId: string;
    name: string;
    status: UnitStatus;
    deletedAt?: string | null;
    canManage: boolean;
    photos: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    unitFiles: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    filesForTenant: Array<{
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    }>;
    comments: Array<{
      __typename?: 'Comment';
      id: string;
      comment: string;
      createdAt: string;
      createdBy?: string | null;
      creator?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    tasks: Array<{
      __typename?: 'Task';
      id: string;
      title: string;
      description?: string | null;
      status: TaskStatus;
      startDate?: string | null;
      dueDate?: string | null;
      completedAt?: string | null;
      assignedTo?: string | null;
      unitId?: string | null;
      contractId?: string | null;
      accountId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      assignee?: {
        __typename?: 'User';
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      } | null;
      lastComment?: {
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      } | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      title: string;
      description?: string | null;
      content: unknown;
      tags: Array<string>;
      unitId?: string | null;
      contractId?: string | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      signedOffByTenantAt?: string | null;
      signedOffByManagerAt?: string | null;
      tenantUserId?: string | null;
      managerUserId?: string | null;
      unit?: { __typename?: 'Unit'; id: string; name: string; address: string } | null;
      contract?: { __typename?: 'Contract'; id: string; title: string } | null;
      tenant?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
      manager?: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null } | null;
    }>;
    expenses: Array<{
      __typename?: 'Expense';
      id: string;
      accountId: string;
      title: string;
      amount: number;
      taxDeductible: number;
      date: string;
      dueDate: string;
      refNo?: string | null;
      paidAt?: string | null;
      paidAmount: number;
      isCost?: boolean | null;
      createdAt: string;
      modifiedAt: string;
      modifiedBy: string;
      deletedAt?: string | null;
      deletedBy?: string | null;
      comments: Array<{
        __typename?: 'Comment';
        id: string;
        comment: string;
        createdAt: string;
        createdBy?: string | null;
        creator?: {
          __typename?: 'User';
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        } | null;
      }>;
      payments: Array<{
        __typename?: 'ExpensePayment';
        id: string;
        accountId: string;
        transactionId: string;
        expenseId: string;
        amount: number;
        createdAt: string;
        createdBy?: string | null;
        deletedAt?: string | null;
        expense?: { __typename?: 'Expense'; id: string; title: string } | null;
      }>;
      unitAssignments: Array<{
        __typename?: 'ExpenseUnitAssignment';
        unitId: string;
        expenseId: string;
        amount: number;
        unit?: { __typename?: 'Unit'; id: string; name: string } | null;
      }>;
    }>;
    coverPhoto?: {
      __typename?: 'FileRef';
      id: string;
      name?: string | null;
      desc?: string | null;
      tags: Array<string>;
      url: string;
      urlXs?: string | null;
      urlMd?: string | null;
      mimeType: string;
      size: number;
      uploadedAt?: string | null;
      deletedAt?: string | null;
    } | null;
  } | null;
};

export type UserPayloadFragment = {
  __typename?: 'UserPayload';
  user?: {
    __typename?: 'User';
    tz: string;
    lang: LanguageType;
    fmtNum: NumberFormatType;
    fmtDate: DateFormatType;
    fmtTime: TimeFormatType;
    isAdmin?: boolean | null;
    isSuperAdmin?: boolean | null;
    createdAt: string;
    disabledAt?: string | null;
    deletedAt?: string | null;
    id: string;
    fullName?: string | null;
    email: string;
    phone?: any | null;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type InvitationPayloadFragment = {
  __typename?: 'InvitationPayload';
  user?: {
    __typename?: 'User';
    tz: string;
    lang: LanguageType;
    fmtNum: NumberFormatType;
    fmtDate: DateFormatType;
    fmtTime: TimeFormatType;
    isAdmin?: boolean | null;
    isSuperAdmin?: boolean | null;
    createdAt: string;
    disabledAt?: string | null;
    deletedAt?: string | null;
    id: string;
    fullName?: string | null;
    email: string;
    phone?: any | null;
  } | null;
  account?: {
    __typename?: 'Account';
    id: string;
    name: string;
    creatorId: string;
    nextInvoiceNo: number;
    autoResetInvoiceNo: boolean;
    bankAccountNo?: string | null;
    bankAccountName?: string | null;
    logoUrl?: string | null;
    statusUpdateFrequency: StatusUpdateFrequency;
    creditNotification: boolean;
    suspendedAt?: string | null;
    deletedAt?: string | null;
    canManage: boolean;
    tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
    members: Array<{
      __typename?: 'AccountMember';
      id: string;
      accountId: string;
      userId: string;
      roles: Array<AccountMemberRole>;
      deletedAt?: string | null;
      member: {
        __typename?: 'User';
        tz: string;
        lang: LanguageType;
        fmtNum: NumberFormatType;
        fmtDate: DateFormatType;
        fmtTime: TimeFormatType;
        isAdmin?: boolean | null;
        isSuperAdmin?: boolean | null;
        createdAt: string;
        disabledAt?: string | null;
        deletedAt?: string | null;
        id: string;
        fullName?: string | null;
        email: string;
        phone?: any | null;
      };
    }>;
    invitations: Array<{
      __typename?: 'AccountInvitation';
      id: string;
      email: any;
      roles: Array<AccountMemberRole>;
      expiresAfter: string;
      invitedBy: string;
      deletedAt?: string | null;
      inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
    }>;
  } | null;
  errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UserPayload';
    user?: {
      __typename?: 'User';
      tz: string;
      lang: LanguageType;
      fmtNum: NumberFormatType;
      fmtDate: DateFormatType;
      fmtTime: TimeFormatType;
      isAdmin?: boolean | null;
      isSuperAdmin?: boolean | null;
      createdAt: string;
      disabledAt?: string | null;
      deletedAt?: string | null;
      id: string;
      fullName?: string | null;
      email: string;
      phone?: any | null;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type AcceptInvitationMutation = {
  __typename?: 'Mutation';
  acceptInvitation: {
    __typename?: 'InvitationPayload';
    user?: {
      __typename?: 'User';
      tz: string;
      lang: LanguageType;
      fmtNum: NumberFormatType;
      fmtDate: DateFormatType;
      fmtTime: TimeFormatType;
      isAdmin?: boolean | null;
      isSuperAdmin?: boolean | null;
      createdAt: string;
      disabledAt?: string | null;
      deletedAt?: string | null;
      id: string;
      fullName?: string | null;
      email: string;
      phone?: any | null;
    } | null;
    account?: {
      __typename?: 'Account';
      id: string;
      name: string;
      creatorId: string;
      nextInvoiceNo: number;
      autoResetInvoiceNo: boolean;
      bankAccountNo?: string | null;
      bankAccountName?: string | null;
      logoUrl?: string | null;
      statusUpdateFrequency: StatusUpdateFrequency;
      creditNotification: boolean;
      suspendedAt?: string | null;
      deletedAt?: string | null;
      canManage: boolean;
      tags: Array<{ __typename?: 'TagDefinition'; entityType: TagEntityType; name: string; color?: string | null }>;
      members: Array<{
        __typename?: 'AccountMember';
        id: string;
        accountId: string;
        userId: string;
        roles: Array<AccountMemberRole>;
        deletedAt?: string | null;
        member: {
          __typename?: 'User';
          tz: string;
          lang: LanguageType;
          fmtNum: NumberFormatType;
          fmtDate: DateFormatType;
          fmtTime: TimeFormatType;
          isAdmin?: boolean | null;
          isSuperAdmin?: boolean | null;
          createdAt: string;
          disabledAt?: string | null;
          deletedAt?: string | null;
          id: string;
          fullName?: string | null;
          email: string;
          phone?: any | null;
        };
      }>;
      invitations: Array<{
        __typename?: 'AccountInvitation';
        id: string;
        email: any;
        roles: Array<AccountMemberRole>;
        expiresAfter: string;
        invitedBy: string;
        deletedAt?: string | null;
        inviter: { __typename?: 'User'; id: string; fullName?: string | null; email: string; phone?: any | null };
      }>;
    } | null;
    errors?: Array<{ __typename?: 'RequestError'; code: any; field?: any | null }> | null;
  };
};

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetUserByIdQuery = {
  __typename?: 'Query';
  getUserById?: {
    __typename?: 'User';
    tz: string;
    lang: LanguageType;
    fmtNum: NumberFormatType;
    fmtDate: DateFormatType;
    fmtTime: TimeFormatType;
    isAdmin?: boolean | null;
    isSuperAdmin?: boolean | null;
    createdAt: string;
    disabledAt?: string | null;
    deletedAt?: string | null;
    id: string;
    fullName?: string | null;
    email: string;
    phone?: any | null;
  } | null;
};

export const UserBaseFragmentDoc = gql`
  fragment UserBase on User {
    id
    fullName
    email
    phone
  }
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    ...UserBase
    tz
    lang
    fmtNum
    fmtDate
    fmtTime
    isAdmin
    isSuperAdmin
    createdAt
    disabledAt
    deletedAt
  }
  ${UserBaseFragmentDoc}
`;
export const AccountMemberFragmentDoc = gql`
  fragment AccountMember on AccountMember {
    id
    accountId
    userId
    roles
    member {
      ...User
    }
    deletedAt
  }
  ${UserFragmentDoc}
`;
export const AccountFragmentDoc = gql`
  fragment Account on Account {
    id
    name
    creatorId
    nextInvoiceNo
    autoResetInvoiceNo
    bankAccountNo
    bankAccountName
    logoUrl
    statusUpdateFrequency
    creditNotification
    tags {
      entityType
      name
      color
    }
    members {
      ...AccountMember
    }
    invitations {
      id
      email
      roles
      expiresAfter
      invitedBy
      inviter {
        ...UserBase
      }
      deletedAt
    }
    suspendedAt
    deletedAt
    canManage
  }
  ${AccountMemberFragmentDoc}
  ${UserBaseFragmentDoc}
`;
export const RequestErrorFragmentDoc = gql`
  fragment RequestError on RequestError {
    code
    field
  }
`;
export const AccountPayloadFragmentDoc = gql`
  fragment AccountPayload on AccountPayload {
    account {
      ...Account
    }
    errors {
      ...RequestError
    }
  }
  ${AccountFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AccountInvitationPayloadFragmentDoc = gql`
  fragment AccountInvitationPayload on AccountInvitationPayload {
    account {
      ...Account
    }
    errors {
      ...RequestError
    }
    invitationLink
    invitationEmail
  }
  ${AccountFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AddressFragmentDoc = gql`
  fragment Address on Address {
    id
    street1
    street2
    city
    state
    zip
    country
  }
`;
export const ContactFragmentDoc = gql`
  fragment Contact on Contact {
    id
    role
    name
    email
    phone
    address {
      ...Address
    }
    company
    companyNo
    taxId
    note
  }
  ${AddressFragmentDoc}
`;
export const UnitBaseFragmentDoc = gql`
  fragment UnitBase on Unit {
    id
    accountId
    name
    status
    deletedAt
    canManage
  }
`;
export const FileRefFragmentDoc = gql`
  fragment FileRef on FileRef {
    id
    name
    desc
    tags
    url
    urlXs
    urlMd
    mimeType
    size
    uploadedAt
    deletedAt
  }
`;
export const UnitListFragmentDoc = gql`
  fragment UnitList on Unit {
    ...UnitBase
    address
    coverPhoto {
      ...FileRef
    }
  }
  ${UnitBaseFragmentDoc}
  ${FileRefFragmentDoc}
`;
export const ContractListFragmentDoc = gql`
  fragment ContractList on Contract {
    id
    contractHid
    title
    note
    contacts {
      ...Contact
    }
    signingDate
    startDate
    endDate
    terminationDate
    terminationReason
    deletedAt
    createdAt
    mainUnit {
      ...UnitList
    }
    canManage
  }
  ${ContactFragmentDoc}
  ${UnitListFragmentDoc}
`;
export const CommentFragmentDoc = gql`
  fragment Comment on Comment {
    id
    comment
    createdAt
    createdBy
    creator {
      ...UserBase
    }
  }
  ${UserBaseFragmentDoc}
`;
export const TaskListFragmentDoc = gql`
  fragment TaskList on Task {
    id
    title
    description
    status
    startDate
    dueDate
    completedAt
    assignedTo
    unitId
    contractId
    accountId
    createdAt
    updatedAt
    deletedAt
    unit {
      id
      name
    }
    contract {
      id
      title
    }
    assignee {
      ...UserBase
    }
    lastComment {
      ...Comment
    }
  }
  ${UserBaseFragmentDoc}
  ${CommentFragmentDoc}
`;
export const TaskFragmentDoc = gql`
  fragment Task on Task {
    ...TaskList
    comments {
      ...Comment
    }
  }
  ${TaskListFragmentDoc}
  ${CommentFragmentDoc}
`;
export const DocumentFragmentDoc = gql`
  fragment Document on Document {
    id
    type
    title
    description
    content
    tags
    unitId
    contractId
    createdAt
    updatedAt
    deletedAt
    signedOffByTenantAt
    signedOffByManagerAt
    tenantUserId
    managerUserId
    unit {
      id
      name
      address
    }
    contract {
      id
      title
    }
    tenant {
      id
      fullName
      email
      phone
    }
    manager {
      id
      fullName
      email
      phone
    }
  }
`;
export const ExpensePaymentFragmentFragmentDoc = gql`
  fragment ExpensePaymentFragment on ExpensePayment {
    id
    accountId
    transactionId
    expenseId
    amount
    createdAt
    createdBy
    deletedAt
    expense {
      id
      title
    }
  }
`;
export const ExpenseUnitAssignmentFragmentFragmentDoc = gql`
  fragment ExpenseUnitAssignmentFragment on ExpenseUnitAssignment {
    unitId
    expenseId
    amount
    unit {
      id
      name
    }
  }
`;
export const ExpenseFragmentDoc = gql`
  fragment Expense on Expense {
    id
    accountId
    title
    amount
    taxDeductible
    date
    dueDate
    refNo
    paidAt
    paidAmount
    isCost
    createdAt
    modifiedAt
    modifiedBy
    deletedAt
    deletedBy
    comments {
      ...Comment
    }
    payments {
      ...ExpensePaymentFragment
    }
    unitAssignments {
      ...ExpenseUnitAssignmentFragment
    }
  }
  ${CommentFragmentDoc}
  ${ExpensePaymentFragmentFragmentDoc}
  ${ExpenseUnitAssignmentFragmentFragmentDoc}
`;
export const UnitFragmentDoc = gql`
  fragment Unit on Unit {
    ...UnitList
    description
    note
    photos {
      ...FileRef
    }
    unitFiles {
      ...FileRef
    }
    filesForTenant {
      ...FileRef
    }
    comments {
      ...Comment
    }
    tasks {
      ...Task
    }
    documents {
      ...Document
    }
    expenses {
      ...Expense
    }
  }
  ${UnitListFragmentDoc}
  ${FileRefFragmentDoc}
  ${CommentFragmentDoc}
  ${TaskFragmentDoc}
  ${DocumentFragmentDoc}
  ${ExpenseFragmentDoc}
`;
export const ContractFragmentDoc = gql`
  fragment Contract on Contract {
    ...ContractList
    mainUnit {
      ...Unit
    }
    units {
      ...UnitList
    }
    files {
      ...FileRef
    }
    comments {
      ...Comment
    }
    documents {
      ...Document
    }
  }
  ${ContractListFragmentDoc}
  ${UnitFragmentDoc}
  ${UnitListFragmentDoc}
  ${FileRefFragmentDoc}
  ${CommentFragmentDoc}
  ${DocumentFragmentDoc}
`;
export const ContractPayloadFragmentDoc = gql`
  fragment ContractPayload on ContractPayload {
    contract {
      ...Contract
    }
    errors {
      ...RequestError
    }
  }
  ${ContractFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AccountBaseFragmentDoc = gql`
  fragment AccountBase on Account {
    id
    name
    plan
    creatorId
    nextInvoiceNo
    autoResetInvoiceNo
    bankAccountNo
    bankAccountName
    logoUrl
    statusUpdateFrequency
    creditNotification
    tags {
      entityType
      name
      color
    }
    suspendedAt
    deletedAt
    canManage
  }
`;
export const FileRefUploadPayloadFragmentDoc = gql`
  fragment FileRefUploadPayload on FileRefUploadPayload {
    uploadUrl
    fileId
  }
`;
export const ContractBaseFragmentDoc = gql`
  fragment ContractBase on Contract {
    id
    title
  }
`;
export const InvoicePaymentFragmentFragmentDoc = gql`
  fragment InvoicePaymentFragment on InvoicePayment {
    id
    accountId
    transactionId
    invoiceId
    amount
    createdAt
    createdBy
    deletedAt
    invoice {
      id
      invoiceNo
    }
  }
`;
export const InvoiceUnitAssignmentFragmentFragmentDoc = gql`
  fragment InvoiceUnitAssignmentFragment on InvoiceUnitAssignment {
    unitId
    invoiceId
    amount
    unit {
      id
      name
    }
  }
`;
export const InvoiceFragmentDoc = gql`
  fragment Invoice on Invoice {
    id
    accountId
    contractId
    invoiceNo
    refNo
    description
    totalAmount
    paidAmount
    isDraft
    issuedAt
    dueDate
    paidAt
    createdAt
    deletedAt
    rows {
      rowNumber
      text
      unit
      quantity
      unitPrice
      discount
      price
    }
    comments {
      ...Comment
    }
    contract {
      ...ContractBase
      unitIds
      units {
        id
        name
      }
    }
    payments {
      ...InvoicePaymentFragment
    }
    unitAssignments {
      ...InvoiceUnitAssignmentFragment
    }
  }
  ${CommentFragmentDoc}
  ${ContractBaseFragmentDoc}
  ${InvoicePaymentFragmentFragmentDoc}
  ${InvoiceUnitAssignmentFragmentFragmentDoc}
`;
export const MoneyTransactionFragmentFragmentDoc = gql`
  fragment MoneyTransactionFragment on MoneyTransaction {
    id
    accountId
    createdAt
    createdBy
    transactionDate
    type
    value
    cash
    bankAccountNo
    otherAccountNo
    note
    reconciledValue
    reference
    doNotReconcile
    invoicePayments {
      ...InvoicePaymentFragment
    }
    expensePayments {
      ...ExpensePaymentFragment
    }
    deletedAt
  }
  ${InvoicePaymentFragmentFragmentDoc}
  ${ExpensePaymentFragmentFragmentDoc}
`;
export const RecurringExpenseUnitAssignmentFragmentFragmentDoc = gql`
  fragment RecurringExpenseUnitAssignmentFragment on RecurringExpenseUnitAssignment {
    unitId
    recExpenseId
    amount
    unit {
      id
      name
    }
  }
`;
export const RecurringExpenseFragmentFragmentDoc = gql`
  fragment RecurringExpenseFragment on RecurringExpense {
    id
    accountId
    title
    amount
    taxDeductible
    refNo
    nextDate
    frequency
    stopAfterDate
    dueDays
    suspended
    createdAt
    deletedAt
    unitAssignments {
      ...RecurringExpenseUnitAssignmentFragment
    }
  }
  ${RecurringExpenseUnitAssignmentFragmentFragmentDoc}
`;
export const RecurringInvoiceUnitAssignmentFragmentFragmentDoc = gql`
  fragment RecurringInvoiceUnitAssignmentFragment on RecurringInvoiceUnitAssignment {
    unitId
    recInvoiceId
    amount
    unit {
      id
      name
    }
  }
`;
export const RecurringInvoiceFragmentFragmentDoc = gql`
  fragment RecurringInvoiceFragment on RecurringInvoice {
    id
    accountId
    contractId
    nextDate
    frequency
    stopAfterDate
    dueDays
    description
    totalAmount
    suspended
    createdAt
    deletedAt
    rows {
      rowNumber
      text
      unit
      quantity
      unitPrice
      discount
      price
    }
    contract {
      id
      title
      unitIds
      units {
        id
        name
      }
    }
    unitAssignments {
      ...RecurringInvoiceUnitAssignmentFragment
    }
  }
  ${RecurringInvoiceUnitAssignmentFragmentFragmentDoc}
`;
export const RecurringTaskFragmentFragmentDoc = gql`
  fragment RecurringTaskFragment on RecurringTask {
    id
    title
    nextDate
    dueDays
    frequency
    stopAfterDate
    description
    suspended
    createdAt
    deletedAt
    unit {
      id
      name
    }
    contract {
      id
      title
    }
    accountId
    unitId
    contractId
  }
`;
export const TaskPayloadFragmentDoc = gql`
  fragment TaskPayload on TaskPayload {
    task {
      ...Task
    }
    errors {
      ...RequestError
    }
  }
  ${TaskFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UnitPayloadFragmentDoc = gql`
  fragment UnitPayload on UnitPayload {
    unit {
      ...Unit
    }
    errors {
      ...RequestError
    }
  }
  ${UnitFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UserPayloadFragmentDoc = gql`
  fragment UserPayload on UserPayload {
    user {
      ...User
    }
    errors {
      ...RequestError
    }
  }
  ${UserFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const InvitationPayloadFragmentDoc = gql`
  fragment InvitationPayload on InvitationPayload {
    user {
      ...User
    }
    account {
      ...Account
    }
    errors {
      ...RequestError
    }
  }
  ${UserFragmentDoc}
  ${AccountFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateAccountDocument = gql`
  mutation updateAccount($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const UploadAccountLogoDocument = gql`
  mutation uploadAccountLogo($input: FileRefUploadInput!) {
    uploadAccountLogo(input: $input) {
      uploadUrl
      logoId
    }
  }
`;
export const ConfirmAccountLogoUploadDocument = gql`
  mutation confirmAccountLogoUpload($logoId: ID!, $size: Int!) {
    confirmAccountLogoUpload(logoId: $logoId, size: $size) {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const RemoveMemberFromAccountDocument = gql`
  mutation removeMemberFromAccount($accountId: ID!, $userId: ID!) {
    removeMemberFromAccount(accountId: $accountId, userId: $userId) {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const InviteUserToAccountDocument = gql`
  mutation inviteUserToAccount($accountId: ID!, $input: CreateAccountInvitationInput!) {
    inviteUserToAccount(accountId: $accountId, input: $input) {
      ...AccountInvitationPayload
    }
  }
  ${AccountInvitationPayloadFragmentDoc}
`;
export const DeleteAccountInvitationDocument = gql`
  mutation deleteAccountInvitation($accountId: ID!, $invitationId: ID!) {
    deleteAccountInvitation(accountId: $accountId, invitationId: $invitationId) {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const SendStatusUpdateDocument = gql`
  mutation sendStatusUpdate {
    sendStatusUpdate {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const SetPlanDocument = gql`
  mutation setPlan($accountId: ID!, $plan: AccountPlan!) {
    setPlan(accountId: $accountId, plan: $plan) {
      ...AccountPayload
    }
  }
  ${AccountPayloadFragmentDoc}
`;
export const GetAccountByIdDocument = gql`
  query getAccountById($id: ID) {
    getAccountById(id: $id) {
      ...Account
    }
  }
  ${AccountFragmentDoc}
`;
export const GetAccountsInvitingUserDocument = gql`
  query getAccountsInvitingUser($email: Email!) {
    getAccountsInvitingUser(email: $email) {
      ...AccountBase
    }
  }
  ${AccountBaseFragmentDoc}
`;
export const GetAccountPlanUsageDocument = gql`
  query getAccountPlanUsage {
    getAccountPlanUsage {
      id
      limitName
      limit
      current
    }
  }
`;
export const CreateContractDocument = gql`
  mutation createContract {
    createContract {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateContractDocument = gql`
  mutation updateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UndeleteContractDocument = gql`
  mutation undeleteContract($contractId: ID!) {
    undeleteContract(contractId: $contractId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const DeleteContractDocument = gql`
  mutation deleteContract($contractId: ID!) {
    deleteContract(contractId: $contractId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const SignContractDocument = gql`
  mutation signContract($contractId: ID!, $signingDate: DateTime!) {
    signContract(contractId: $contractId, signingDate: $signingDate) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UnsignContractDocument = gql`
  mutation unsignContract($contractId: ID!) {
    unsignContract(contractId: $contractId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const TerminateContractDocument = gql`
  mutation terminateContract($contractId: ID!, $terminationDate: DateTime!, $reason: String) {
    terminateContract(contractId: $contractId, terminationDate: $terminationDate, reason: $reason) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UnterminateContractDocument = gql`
  mutation unterminateContract($contractId: ID!) {
    unterminateContract(contractId: $contractId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const AddUnitToContractDocument = gql`
  mutation addUnitToContract($contractId: ID!, $unitId: ID!) {
    addUnitToContract(contractId: $contractId, unitId: $unitId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const RemoveUnitFromContractDocument = gql`
  mutation removeUnitFromContract($contractId: ID!, $unitId: ID!) {
    removeUnitFromContract(contractId: $contractId, unitId: $unitId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const AddFileToContractDocument = gql`
  mutation addFileToContract($contractId: ID!, $type: FileRefDocType!, $input: FileRefUploadInput!) {
    addFileToContract(contractId: $contractId, type: $type, input: $input) {
      ...FileRefUploadPayload
    }
  }
  ${FileRefUploadPayloadFragmentDoc}
`;
export const ConfirmFileUploadedToContractDocument = gql`
  mutation confirmFileUploadedToContract($contractId: ID!, $fileId: ID!, $size: Int!) {
    confirmFileUploadedToContract(contractId: $contractId, fileId: $fileId, size: $size) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateFileInContractDocument = gql`
  mutation updateFileInContract($contractId: ID!, $fileId: ID!, $input: UpdateFileInput!) {
    updateFileInContract(contractId: $contractId, fileId: $fileId, input: $input) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const DeleteFileFromContractDocument = gql`
  mutation deleteFileFromContract($contractId: ID!, $fileId: ID!) {
    deleteFileFromContract(contractId: $contractId, fileId: $fileId) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const AddContactToContractDocument = gql`
  mutation addContactToContract($contractId: ID!, $input: ContactCreateInput!) {
    addContactToContract(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const RemoveContactFromContractDocument = gql`
  mutation removeContactFromContract($contractId: ID!, $contactId: ID!) {
    removeContactFromContract(contractId: $contractId, contactId: $contactId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateContactInContractDocument = gql`
  mutation updateContactInContract($contractId: ID!, $input: ContactUpdateInput!) {
    updateContactInContract(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const AddTenantToContractDocument = gql`
  mutation addTenantToContract($contractId: ID!, $input: ContactCreateInput) {
    addTenantToContract(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const RemoveTenantFromContractDocument = gql`
  mutation removeTenantFromContract($contractId: ID!, $tenantId: ID!) {
    removeTenantFromContract(contractId: $contractId, tenantId: $tenantId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateTenantInContractDocument = gql`
  mutation updateTenantInContract($contractId: ID!, $input: ContactUpdateInput!) {
    updateTenantInContract(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const AddContractCommentDocument = gql`
  mutation addContractComment($contractId: ID!, $input: CreateCommentInput!) {
    addContractComment(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateContractCommentDocument = gql`
  mutation updateContractComment($contractId: ID!, $input: UpdateCommentInput!) {
    updateContractComment(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const RemoveContractCommentDocument = gql`
  mutation removeContractComment($contractId: ID!, $commentId: ID!) {
    removeContractComment(contractId: $contractId, commentId: $commentId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const AddDocumentToContractDocument = gql`
  mutation addDocumentToContract($contractId: ID!, $input: CreateDocumentInput!) {
    addDocumentToContract(contractId: $contractId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const DeleteDocumentFromContractDocument = gql`
  mutation deleteDocumentFromContract($contractId: ID!, $documentId: ID!) {
    deleteDocumentFromContract(contractId: $contractId, documentId: $documentId) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const UpdateDocumentInContractDocument = gql`
  mutation updateDocumentInContract($contractId: ID!, $documentId: ID!, $input: UpdateDocumentInput!) {
    updateDocumentInContract(contractId: $contractId, documentId: $documentId, input: $input) {
      ...ContractPayload
    }
  }
  ${ContractPayloadFragmentDoc}
`;
export const GetContractsDocument = gql`
  query getContracts {
    getContracts {
      ...Contract
    }
  }
  ${ContractFragmentDoc}
`;
export const GetContractDocument = gql`
  query getContract($id: ID!) {
    getContract(id: $id) {
      ...Contract
    }
  }
  ${ContractFragmentDoc}
`;
export const AddFileAttachmentToDocumentDocument = gql`
  mutation addFileAttachmentToDocument($documentId: ID!, $type: FileRefDocType!, $input: FileRefUploadInput) {
    addFileAttachmentToDocument(documentId: $documentId, type: $type, input: $input) {
      ...FileRefUploadPayload
    }
  }
  ${FileRefUploadPayloadFragmentDoc}
`;
export const ConfirmFileAttachmentUploadedToDocumentDocument = gql`
  mutation confirmFileAttachmentUploadedToDocument($documentId: ID!, $fileId: ID!, $size: Int!) {
    confirmFileAttachmentUploadedToDocument(documentId: $documentId, fileId: $fileId, size: $size) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const AddUrlAttachmentToDocumentDocument = gql`
  mutation addUrlAttachmentToDocument($documentId: ID!, $type: FileRefDocType!, $url: String!) {
    addUrlAttachmentToDocument(documentId: $documentId, type: $type, url: $url) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const DeleteAttachmentFromDocumentDocument = gql`
  mutation deleteAttachmentFromDocument($documentId: ID!, $fileId: ID!) {
    deleteAttachmentFromDocument(documentId: $documentId, fileId: $fileId) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const GetDocumentDocument = gql`
  query getDocument($documentId: ID!) {
    getDocument(documentId: $documentId) {
      ...Document
    }
  }
  ${DocumentFragmentDoc}
`;
export const GetDocumentsForContractDocument = gql`
  query getDocumentsForContract($contractId: ID!) {
    getDocumentsForContract(contractId: $contractId) {
      ...Document
    }
  }
  ${DocumentFragmentDoc}
`;
export const GetDocumentsForUnitDocument = gql`
  query getDocumentsForUnit($unitId: ID!) {
    getDocumentsForUnit(unitId: $unitId) {
      ...Document
    }
  }
  ${DocumentFragmentDoc}
`;
export const CreateExpensePaymentDocument = gql`
  mutation CreateExpensePayment($input: CreateExpensePaymentInput!) {
    createExpensePayment(input: $input) {
      expensePayment {
        ...ExpensePaymentFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpensePaymentFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteExpensePaymentDocument = gql`
  mutation DeleteExpensePayment($id: ID!) {
    deleteExpensePayment(id: $id) {
      expensePayment {
        ...ExpensePaymentFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpensePaymentFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetExpensePaymentDocument = gql`
  query GetExpensePayment($id: ID!) {
    getExpensePayment(id: $id) {
      ...ExpensePaymentFragment
    }
  }
  ${ExpensePaymentFragmentFragmentDoc}
`;
export const GetExpensePaymentsForExpenseDocument = gql`
  query GetExpensePaymentsForExpense($expenseId: ID!) {
    getExpensePaymentsForExpense(expenseId: $expenseId) {
      ...ExpensePaymentFragment
    }
  }
  ${ExpensePaymentFragmentFragmentDoc}
`;
export const GetUnpaidExpensesDocument = gql`
  query GetUnpaidExpenses {
    getUnpaidExpenses {
      ...Expense
    }
  }
  ${ExpenseFragmentDoc}
`;
export const CreateExpenseDocument = gql`
  mutation CreateExpense($input: CreateExpenseInput!) {
    createExpense(input: $input) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateExpenseDocument = gql`
  mutation UpdateExpense($expenseId: ID!, $input: UpdateExpenseInput!) {
    updateExpense(expenseId: $expenseId, input: $input) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteExpenseDocument = gql`
  mutation DeleteExpense($expenseId: ID!) {
    deleteExpense(expenseId: $expenseId) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UndeleteExpenseDocument = gql`
  mutation UndeleteExpense($expenseId: ID!) {
    undeleteExpense(expenseId: $expenseId) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MarkExpensePaidDocument = gql`
  mutation MarkExpensePaid($expenseId: ID!, $paidAt: DateTime!) {
    markExpensePaid(expenseId: $expenseId, paidAt: $paidAt) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MarkExpenseUnpaidDocument = gql`
  mutation MarkExpenseUnpaid($expenseId: ID!) {
    markExpenseUnpaid(expenseId: $expenseId) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AddExpenseCommentDocument = gql`
  mutation AddExpenseComment($expenseId: ID!, $input: CreateCommentInput!) {
    addExpenseComment(expenseId: $expenseId, input: $input) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateExpenseCommentDocument = gql`
  mutation UpdateExpenseComment($expenseId: ID!, $input: UpdateCommentInput!) {
    updateExpenseComment(expenseId: $expenseId, input: $input) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const RemoveExpenseCommentDocument = gql`
  mutation RemoveExpenseComment($expenseId: ID!, $commentId: ID!) {
    removeExpenseComment(expenseId: $expenseId, commentId: $commentId) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SetExpenseUnitAssignmentsDocument = gql`
  mutation SetExpenseUnitAssignments($expenseId: ID!, $assignments: [ExpenseUnitAssignmentInput!]!) {
    setExpenseUnitAssignments(expenseId: $expenseId, assignments: $assignments) {
      expense {
        ...Expense
      }
      errors {
        ...RequestError
      }
    }
  }
  ${ExpenseFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetExpenseDocument = gql`
  query GetExpense($id: ID!) {
    getExpense(id: $id) {
      ...Expense
    }
  }
  ${ExpenseFragmentDoc}
`;
export const GetExpensesForAccountDocument = gql`
  query GetExpensesForAccount {
    getExpensesForAccount {
      ...Expense
    }
  }
  ${ExpenseFragmentDoc}
`;
export const GetExpensesForUnitDocument = gql`
  query GetExpensesForUnit($unitId: ID!) {
    getExpensesForUnit(unitId: $unitId) {
      ...Expense
    }
  }
  ${ExpenseFragmentDoc}
`;
export const CreateInvoicePaymentDocument = gql`
  mutation CreateInvoicePayment($input: CreateInvoicePaymentInput!) {
    createInvoicePayment(input: $input) {
      invoicePayment {
        ...InvoicePaymentFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoicePaymentFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteInvoicePaymentDocument = gql`
  mutation DeleteInvoicePayment($id: ID!) {
    deleteInvoicePayment(id: $id) {
      invoicePayment {
        ...InvoicePaymentFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoicePaymentFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetInvoicePaymentDocument = gql`
  query GetInvoicePayment($id: ID!) {
    getInvoicePayment(id: $id) {
      ...InvoicePaymentFragment
    }
  }
  ${InvoicePaymentFragmentFragmentDoc}
`;
export const GetInvoicePaymentsForTransactionDocument = gql`
  query GetInvoicePaymentsForTransaction($transactionId: ID!) {
    getInvoicePaymentsForTransaction(transactionId: $transactionId) {
      ...InvoicePaymentFragment
    }
  }
  ${InvoicePaymentFragmentFragmentDoc}
`;
export const GetInvoicePaymentsForInvoiceDocument = gql`
  query GetInvoicePaymentsForInvoice($invoiceId: ID!) {
    getInvoicePaymentsForInvoice(invoiceId: $invoiceId) {
      ...InvoicePaymentFragment
    }
  }
  ${InvoicePaymentFragmentFragmentDoc}
`;
export const GetUnpaidInvoicesDocument = gql`
  query GetUnpaidInvoices {
    getUnpaidInvoices {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export const CreateInvoiceDocument = gql`
  mutation createInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateInvoiceDocument = gql`
  mutation updateInvoice($invoiceId: ID!, $input: UpdateInvoiceInput!) {
    updateInvoice(invoiceId: $invoiceId, input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteInvoiceDocument = gql`
  mutation deleteInvoice($invoiceId: ID!) {
    deleteInvoice(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UndeleteInvoiceDocument = gql`
  mutation undeleteInvoice($invoiceId: ID!) {
    undeleteInvoice(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MarkInvoicePaidDocument = gql`
  mutation markInvoicePaid($invoiceId: ID!, $paidAt: DateTime!) {
    markInvoicePaid(invoiceId: $invoiceId, paidAt: $paidAt) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MarkInvoiceUnpaidDocument = gql`
  mutation markInvoiceUnpaid($invoiceId: ID!) {
    markInvoiceUnpaid(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const CopyInvoiceDocument = gql`
  mutation copyInvoice($invoiceId: ID!) {
    copyInvoice(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AddInvoiceCommentDocument = gql`
  mutation addInvoiceComment($invoiceId: ID!, $input: CreateCommentInput!) {
    addInvoiceComment(invoiceId: $invoiceId, input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateInvoiceCommentDocument = gql`
  mutation updateInvoiceComment($invoiceId: ID!, $input: UpdateCommentInput!) {
    updateInvoiceComment(invoiceId: $invoiceId, input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const RemoveInvoiceCommentDocument = gql`
  mutation removeInvoiceComment($invoiceId: ID!, $commentId: ID!) {
    removeInvoiceComment(invoiceId: $invoiceId, commentId: $commentId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const AddInvoiceRowDocument = gql`
  mutation addInvoiceRow($invoiceId: ID!, $input: InvoiceRowInput!) {
    addInvoiceRow(invoiceId: $invoiceId, input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateInvoiceRowDocument = gql`
  mutation updateInvoiceRow($invoiceId: ID!, $rowNumber: Int!, $input: InvoiceRowInput!) {
    updateInvoiceRow(invoiceId: $invoiceId, rowNumber: $rowNumber, input: $input) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const RemoveInvoiceRowDocument = gql`
  mutation removeInvoiceRow($invoiceId: ID!, $rowNumber: Int!) {
    removeInvoiceRow(invoiceId: $invoiceId, rowNumber: $rowNumber) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MoveInvoiceRowUpDocument = gql`
  mutation moveInvoiceRowUp($invoiceId: ID!, $rowNumber: Int!) {
    moveInvoiceRowUp(invoiceId: $invoiceId, rowNumber: $rowNumber) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const MoveInvoiceRowDownDocument = gql`
  mutation moveInvoiceRowDown($invoiceId: ID!, $rowNumber: Int!) {
    moveInvoiceRowDown(invoiceId: $invoiceId, rowNumber: $rowNumber) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SendPaymentConfirmationDocument = gql`
  mutation sendPaymentConfirmation($invoiceId: ID!) {
    sendPaymentConfirmation(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SendInvoiceInformationEmailDocument = gql`
  mutation sendInvoiceInformationEmail($invoiceId: ID!, $emails: String, $includeDefaultRecipients: Boolean!) {
    sendInvoiceInformationEmail(
      invoiceId: $invoiceId
      emails: $emails
      includeDefaultRecipients: $includeDefaultRecipients
    ) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const IssueInvoiceDocument = gql`
  mutation issueInvoice($invoiceId: ID!) {
    issueInvoice(invoiceId: $invoiceId) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SetInvoiceUnitAssignmentsDocument = gql`
  mutation setInvoiceUnitAssignments($invoiceId: ID!, $assignments: [InvoiceUnitAssignmentInput!]!) {
    setInvoiceUnitAssignments(invoiceId: $invoiceId, assignments: $assignments) {
      invoice {
        ...Invoice
      }
      errors {
        ...RequestError
      }
    }
  }
  ${InvoiceFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetInvoiceDocument = gql`
  query getInvoice($id: ID!) {
    getInvoice(id: $id) {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export const GetInvoicesForContractDocument = gql`
  query getInvoicesForContract($contractId: ID!) {
    getInvoicesForContract(contractId: $contractId) {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export const GetInvoicesForAccountDocument = gql`
  query getInvoicesForAccount {
    getInvoicesForAccount {
      ...Invoice
    }
  }
  ${InvoiceFragmentDoc}
`;
export const CreateMoneyTransactionDocument = gql`
  mutation CreateMoneyTransaction($input: CreateMoneyTransactionInput!) {
    createMoneyTransaction(input: $input) {
      moneyTransaction {
        ...MoneyTransactionFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${MoneyTransactionFragmentFragmentDoc}
`;
export const UpdateMoneyTransactionDocument = gql`
  mutation UpdateMoneyTransaction($input: UpdateMoneyTransactionInput!) {
    updateMoneyTransaction(input: $input) {
      moneyTransaction {
        ...MoneyTransactionFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${MoneyTransactionFragmentFragmentDoc}
`;
export const DeleteMoneyTransactionDocument = gql`
  mutation DeleteMoneyTransaction($id: ID!) {
    deleteMoneyTransaction(id: $id) {
      moneyTransaction {
        ...MoneyTransactionFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${MoneyTransactionFragmentFragmentDoc}
`;
export const GetMoneyTransactionsForAccountDocument = gql`
  query GetMoneyTransactionsForAccount($filter: MoneyTransactionFilterInput) {
    getMoneyTransactionsForAccount(filter: $filter) {
      ...MoneyTransactionFragment
    }
  }
  ${MoneyTransactionFragmentFragmentDoc}
`;
export const GetMoneyTransactionDocument = gql`
  query GetMoneyTransaction($id: ID!) {
    getMoneyTransaction(id: $id) {
      ...MoneyTransactionFragment
    }
  }
  ${MoneyTransactionFragmentFragmentDoc}
`;
export const UpdateNotificationSettingsDocument = gql`
  mutation updateNotificationSettings($accountId: ID!, $input: UpdateNotificationSettingsInput!) {
    updateNotificationSettings(accountId: $accountId, input: $input) {
      notificationSettings {
        id
        accountId
        notifications {
          id
          daysBefore
          subject
          text
          active
          createdAt
        }
        paymentConfirmationEnabled
        paymentConfirmationSubject
        paymentConfirmationText
        invoiceInformationSubject
        invoiceInformationText
        notificationBccEmails
        createdAt
        updatedAt
      }
      errors {
        code
        field
      }
    }
  }
`;
export const GetNotificationSettingsDocument = gql`
  query getNotificationSettings($accountId: ID!) {
    getNotificationSettings(accountId: $accountId) {
      id
      accountId
      notifications {
        id
        daysBefore
        subject
        text
        active
        createdAt
      }
      paymentConfirmationEnabled
      paymentConfirmationSubject
      paymentConfirmationText
      invoiceInformationSubject
      invoiceInformationText
      notificationBccEmails
      createdAt
      updatedAt
    }
  }
`;
export const CreateRecurringExpenseDocument = gql`
  mutation CreateRecurringExpense($input: CreateRecurringExpenseInput!) {
    createRecurringExpense(input: $input) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateRecurringExpenseDocument = gql`
  mutation UpdateRecurringExpense($input: UpdateRecurringExpenseInput!) {
    updateRecurringExpense(input: $input) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteRecurringExpenseDocument = gql`
  mutation DeleteRecurringExpense($recurringExpenseId: ID!) {
    deleteRecurringExpense(recurringExpenseId: $recurringExpenseId) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SuspendRecurringExpenseDocument = gql`
  mutation SuspendRecurringExpense($recurringExpenseId: ID!) {
    suspendRecurringExpense(recurringExpenseId: $recurringExpenseId) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UnsuspendRecurringExpenseDocument = gql`
  mutation UnsuspendRecurringExpense($recurringExpenseId: ID!) {
    unsuspendRecurringExpense(recurringExpenseId: $recurringExpenseId) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SetRecurringExpenseUnitAssignmentsDocument = gql`
  mutation SetRecurringExpenseUnitAssignments(
    $recurringExpenseId: ID!
    $assignments: [RecurringExpenseUnitAssignmentInput!]!
  ) {
    setRecurringExpenseUnitAssignments(recurringExpenseId: $recurringExpenseId, assignments: $assignments) {
      recurringExpense {
        ...RecurringExpenseFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetRecurringExpenseDocument = gql`
  query GetRecurringExpense($id: ID!) {
    getRecurringExpense(id: $id) {
      ...RecurringExpenseFragment
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
`;
export const GetRecurringExpensesForAccountDocument = gql`
  query GetRecurringExpensesForAccount {
    getRecurringExpensesForAccount {
      ...RecurringExpenseFragment
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
`;
export const GetRecurringExpensesForUnitDocument = gql`
  query GetRecurringExpensesForUnit($unitId: ID!) {
    getRecurringExpensesForUnit(unitId: $unitId) {
      ...RecurringExpenseFragment
    }
  }
  ${RecurringExpenseFragmentFragmentDoc}
`;
export const CreateRecurringInvoiceDocument = gql`
  mutation CreateRecurringInvoice($input: CreateRecurringInvoiceInput!) {
    createRecurringInvoice(input: $input) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const UpdateRecurringInvoiceDocument = gql`
  mutation UpdateRecurringInvoice($input: UpdateRecurringInvoiceInput!) {
    updateRecurringInvoice(input: $input) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const DeleteRecurringInvoiceDocument = gql`
  mutation DeleteRecurringInvoice($recurringInvoiceId: ID!) {
    deleteRecurringInvoice(recurringInvoiceId: $recurringInvoiceId) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const UndeleteRecurringInvoiceDocument = gql`
  mutation UndeleteRecurringInvoice($recurringInvoiceId: ID!) {
    undeleteRecurringInvoice(recurringInvoiceId: $recurringInvoiceId) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const SuspendRecurringInvoiceDocument = gql`
  mutation SuspendRecurringInvoice($recurringInvoiceId: ID!) {
    suspendRecurringInvoice(recurringInvoiceId: $recurringInvoiceId) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const UnsuspendRecurringInvoiceDocument = gql`
  mutation UnsuspendRecurringInvoice($recurringInvoiceId: ID!) {
    unsuspendRecurringInvoice(recurringInvoiceId: $recurringInvoiceId) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const CopyRecurringInvoiceDocument = gql`
  mutation CopyRecurringInvoice($recurringInvoiceId: ID!) {
    copyRecurringInvoice(recurringInvoiceId: $recurringInvoiceId) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const AddRecurringInvoiceRowDocument = gql`
  mutation addRecurringInvoiceRow($recurringInvoiceId: ID!, $input: RecurringInvoiceRowInput!) {
    addRecurringInvoiceRow(recurringInvoiceId: $recurringInvoiceId, input: $input) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const UpdateRecurringInvoiceRowDocument = gql`
  mutation updateRecurringInvoiceRow($recurringInvoiceId: ID!, $rowNumber: Int!, $input: RecurringInvoiceRowInput!) {
    updateRecurringInvoiceRow(recurringInvoiceId: $recurringInvoiceId, rowNumber: $rowNumber, input: $input) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const RemoveRecurringInvoiceRowDocument = gql`
  mutation removeRecurringInvoiceRow($recurringInvoiceId: ID!, $rowNumber: Int!) {
    removeRecurringInvoiceRow(recurringInvoiceId: $recurringInvoiceId, rowNumber: $rowNumber) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const MoveRecurringInvoiceRowUpDocument = gql`
  mutation moveRecurringInvoiceRowUp($recurringInvoiceId: ID!, $rowNumber: Int!) {
    moveRecurringInvoiceRowUp(recurringInvoiceId: $recurringInvoiceId, rowNumber: $rowNumber) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const MoveRecurringInvoiceRowDownDocument = gql`
  mutation moveRecurringInvoiceRowDown($recurringInvoiceId: ID!, $rowNumber: Int!) {
    moveRecurringInvoiceRowDown(recurringInvoiceId: $recurringInvoiceId, rowNumber: $rowNumber) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const SetRecurringInvoiceUnitAssignmentsDocument = gql`
  mutation SetRecurringInvoiceUnitAssignments(
    $recurringInvoiceId: ID!
    $assignments: [RecurringInvoiceUnitAssignmentInput!]!
  ) {
    setRecurringInvoiceUnitAssignments(recurringInvoiceId: $recurringInvoiceId, assignments: $assignments) {
      recurringInvoice {
        ...RecurringInvoiceFragment
      }
      errors {
        code
        field
      }
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const GetRecurringInvoicesForContractDocument = gql`
  query GetRecurringInvoicesForContract($contractId: ID!) {
    getRecurringInvoicesForContract(contractId: $contractId) {
      ...RecurringInvoiceFragment
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const GetRecurringInvoiceDocument = gql`
  query GetRecurringInvoice($id: ID!) {
    getRecurringInvoice(id: $id) {
      ...RecurringInvoiceFragment
    }
  }
  ${RecurringInvoiceFragmentFragmentDoc}
`;
export const CreateRecurringTaskDocument = gql`
  mutation CreateRecurringTask($input: CreateRecurringTaskInput!) {
    createRecurringTask(input: $input) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UpdateRecurringTaskDocument = gql`
  mutation UpdateRecurringTask($recurringTaskId: ID!, $input: UpdateRecurringTaskInput!) {
    updateRecurringTask(recurringTaskId: $recurringTaskId, input: $input) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const DeleteRecurringTaskDocument = gql`
  mutation DeleteRecurringTask($recurringTaskId: ID!) {
    deleteRecurringTask(recurringTaskId: $recurringTaskId) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UndeleteRecurringTaskDocument = gql`
  mutation UndeleteRecurringTask($recurringTaskId: ID!) {
    undeleteRecurringTask(recurringTaskId: $recurringTaskId) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const SuspendRecurringTaskDocument = gql`
  mutation SuspendRecurringTask($recurringTaskId: ID!) {
    suspendRecurringTask(recurringTaskId: $recurringTaskId) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const UnsuspendRecurringTaskDocument = gql`
  mutation UnsuspendRecurringTask($recurringTaskId: ID!) {
    unsuspendRecurringTask(recurringTaskId: $recurringTaskId) {
      recurringTask {
        ...RecurringTaskFragment
      }
      errors {
        ...RequestError
      }
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
  ${RequestErrorFragmentDoc}
`;
export const GetRecurringTaskDocument = gql`
  query GetRecurringTask($id: ID!) {
    getRecurringTask(id: $id) {
      ...RecurringTaskFragment
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
`;
export const GetRecurringTasksForAccountDocument = gql`
  query GetRecurringTasksForAccount {
    getRecurringTasksForAccount {
      ...RecurringTaskFragment
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
`;
export const GetRecurringTasksForUnitDocument = gql`
  query GetRecurringTasksForUnit($unitId: ID!) {
    getRecurringTasksForUnit(unitId: $unitId) {
      ...RecurringTaskFragment
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
`;
export const GetRecurringTasksForContractDocument = gql`
  query GetRecurringTasksForContract($contractId: ID!) {
    getRecurringTasksForContract(contractId: $contractId) {
      ...RecurringTaskFragment
    }
  }
  ${RecurringTaskFragmentFragmentDoc}
`;
export const CreateTaskDocument = gql`
  mutation createTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const UpdateTaskDocument = gql`
  mutation updateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const DeleteTaskDocument = gql`
  mutation deleteTask($taskId: ID!) {
    deleteTask(taskId: $taskId) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const UndeleteTaskDocument = gql`
  mutation undeleteTask($taskId: ID!) {
    undeleteTask(taskId: $taskId) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const AddTaskCommentDocument = gql`
  mutation addTaskComment($taskId: ID!, $input: CreateCommentInput!) {
    addTaskComment(taskId: $taskId, input: $input) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const UpdateTaskCommentDocument = gql`
  mutation updateTaskComment($taskId: ID!, $input: UpdateCommentInput!) {
    updateTaskComment(taskId: $taskId, input: $input) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const DeleteTaskCommentDocument = gql`
  mutation deleteTaskComment($taskId: ID!, $commentId: ID!) {
    deleteTaskComment(taskId: $taskId, commentId: $commentId) {
      ...TaskPayload
    }
  }
  ${TaskPayloadFragmentDoc}
`;
export const GetTaskDocument = gql`
  query getTask($taskId: ID!) {
    getTask(taskId: $taskId) {
      ...Task
    }
  }
  ${TaskFragmentDoc}
`;
export const GetTasksDocument = gql`
  query getTasks {
    getTasks {
      ...TaskList
    }
  }
  ${TaskListFragmentDoc}
`;
export const GetTasksForContractDocument = gql`
  query getTasksForContract($contractId: ID!) {
    getTasksForContract(contractId: $contractId) {
      ...TaskList
    }
  }
  ${TaskListFragmentDoc}
`;
export const GetTasksForUnitDocument = gql`
  query getTasksForUnit($unitId: ID!) {
    getTasksForUnit(unitId: $unitId) {
      ...TaskList
    }
  }
  ${TaskListFragmentDoc}
`;
export const CreateUnitDocument = gql`
  mutation createUnit($input: CreateUnitInput!) {
    createUnit(input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UpdateUnitDocument = gql`
  mutation updateUnit($input: UpdateUnitInput!) {
    updateUnit(input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const DeleteUnitDocument = gql`
  mutation deleteUnit($unitId: ID!) {
    deleteUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UndeleteUnitDocument = gql`
  mutation undeleteUnit($unitId: ID!) {
    undeleteUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const StartRentingUnitDocument = gql`
  mutation startRentingUnit($unitId: ID!) {
    startRentingUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const StopRentingUnitDocument = gql`
  mutation stopRentingUnit($unitId: ID!) {
    stopRentingUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const ArchiveUnitDocument = gql`
  mutation archiveUnit($unitId: ID!) {
    archiveUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UnarchiveUnitDocument = gql`
  mutation unarchiveUnit($unitId: ID!) {
    unarchiveUnit(unitId: $unitId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const SetUnitCoverPhotoDocument = gql`
  mutation setUnitCoverPhoto($unitId: ID!, $photoId: ID!) {
    setUnitCoverPhoto(unitId: $unitId, photoId: $photoId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const ConfirmUnitPhotoUploadDocument = gql`
  mutation confirmUnitPhotoUpload($unitId: ID!, $photoId: ID!, $size: Int!) {
    confirmUnitPhotoUpload(unitId: $unitId, photoId: $photoId, size: $size) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const AddUnitPhotoDocument = gql`
  mutation addUnitPhoto($unitId: ID!, $input: FileRefUploadInput!) {
    addUnitPhoto(unitId: $unitId, input: $input) {
      ...FileRefUploadPayload
    }
  }
  ${FileRefUploadPayloadFragmentDoc}
`;
export const DeleteUnitPhotoDocument = gql`
  mutation deleteUnitPhoto($unitId: ID!, $photoId: ID!) {
    deleteUnitPhoto(unitId: $unitId, photoId: $photoId) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const UpdateUnitPhotoCaptionDocument = gql`
  mutation updateUnitPhotoCaption($unitId: ID!, $photoId: ID!, $caption: String!) {
    updateUnitPhotoCaption(unitId: $unitId, photoId: $photoId, caption: $caption) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const AddFileToUnitDocument = gql`
  mutation addFileToUnit($unitId: ID!, $type: FileRefDocType!, $input: FileRefUploadInput!) {
    addFileToUnit(unitId: $unitId, type: $type, input: $input) {
      ...FileRefUploadPayload
      fileId
    }
  }
  ${FileRefUploadPayloadFragmentDoc}
`;
export const ConfirmFileUploadedToUnitDocument = gql`
  mutation confirmFileUploadedToUnit($unitId: ID!, $fileId: ID!, $size: Int!) {
    confirmFileUploadedToUnit(unitId: $unitId, fileId: $fileId, size: $size) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UpdateFileInUnitDocument = gql`
  mutation updateFileInUnit($unitId: ID!, $fileId: ID!, $input: UpdateFileInput!) {
    updateFileInUnit(unitId: $unitId, fileId: $fileId, input: $input) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const DeleteFileFromUnitDocument = gql`
  mutation deleteFileFromUnit($unitId: ID!, $fileId: ID!) {
    deleteFileFromUnit(unitId: $unitId, fileId: $fileId) {
      ...FileRef
    }
  }
  ${FileRefFragmentDoc}
`;
export const AddUnitCommentDocument = gql`
  mutation addUnitComment($unitId: ID!, $input: CreateCommentInput!) {
    addUnitComment(unitId: $unitId, input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UpdateUnitCommentDocument = gql`
  mutation updateUnitComment($unitId: ID!, $input: UpdateCommentInput!) {
    updateUnitComment(unitId: $unitId, input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const RemoveUnitCommentDocument = gql`
  mutation removeUnitComment($unitId: ID!, $commentId: ID!) {
    removeUnitComment(unitId: $unitId, commentId: $commentId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const AddDocumentToUnitDocument = gql`
  mutation addDocumentToUnit($unitId: ID!, $input: CreateDocumentInput!) {
    addDocumentToUnit(unitId: $unitId, input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const DeleteDocumentFromUnitDocument = gql`
  mutation deleteDocumentFromUnit($unitId: ID!, $documentId: ID!) {
    deleteDocumentFromUnit(unitId: $unitId, documentId: $documentId) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const UpdateDocumentInUnitDocument = gql`
  mutation updateDocumentInUnit($unitId: ID!, $documentId: ID!, $input: UpdateDocumentInput!) {
    updateDocumentInUnit(unitId: $unitId, documentId: $documentId, input: $input) {
      ...UnitPayload
    }
  }
  ${UnitPayloadFragmentDoc}
`;
export const GetUnitsDocument = gql`
  query getUnits($includeArchived: Boolean) {
    getUnits(includeArchived: $includeArchived) {
      ...UnitList
    }
  }
  ${UnitListFragmentDoc}
`;
export const GetUnitDocument = gql`
  query getUnit($id: ID!) {
    getUnit(id: $id) {
      ...Unit
    }
  }
  ${UnitFragmentDoc}
`;
export const UpdateUserDocument = gql`
  mutation updateUser($userId: ID!, $input: UpdateUserInput!) {
    updateUser(userId: $userId, input: $input) {
      ...UserPayload
    }
  }
  ${UserPayloadFragmentDoc}
`;
export const AcceptInvitationDocument = gql`
  mutation acceptInvitation($token: String!) {
    acceptInvitation(token: $token) {
      ...InvitationPayload
    }
  }
  ${InvitationPayloadFragmentDoc}
`;
export const GetUserByIdDocument = gql`
  query getUserById($userId: ID!) {
    getUserById(userId: $userId) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
